import {ReplaySubject} from "rxjs";
import "rxjs/add/operator/skip";
import {ArrayUtil} from "../js/util/ArrayUtil";
import {ObjectUtil} from "../js/util/ObjectUtil";
import {sum} from "../js/util/UtilFunctions";
import {isOrderClientEvent, isPortfoliosUpdatedClientEvent} from "../services/client-events/models/ClientEventRecord";
import {ClientEventType} from "../services/client-events/models/ClientEventType";
import {SystemEvent} from "../services/system-state/SystemEvent";
import "./Portfolio.scss";
import {PortfolioService} from "./service/PortfolioService";
import {QuickWhatIfService} from "./service/QuickWhatIfService";
import Sidebar from "./sidebar";
import Collateral from "./templates/collateral";

{
    var app = angular.module("tf.portfolio", ["tf.portfolio.widgets.raSecurity", "tf.portfolio.widgets.whatIfComparison", "tf.portfolio.widgets.raPortfolio", "tf.portfolio.widgets.deltaChart", "tf.portfolio.widgets.tradersCircle", "tf.portfolio.newBusiness", "tf.portfolio.ticket", "tf.portfolio.whatIfMobile", "tf.portfolio.widgets.icConcession", "tf.portfolio.widgets.whtIfChart", "tf.portfolio.widgets.breakdownChart", "tf.portfolio.widgets.tf-payoff", Collateral, Sidebar])

                     .service(PortfolioService.id, PortfolioService)

                     .directive("legCount", function () {
                         return {
                             require: "ngModel",
                             link: function (scope, elm, attrs, ngModel) {
                                 scope.$watch(attrs.ngModel, function (value) {
                                     ngModel.$setValidity("legCount", value.length >= 1 && value.length <= 4);
                                 });
                             }
                         };
                     })
                     .directive("sameUnderlying", function () {
                         return {
                             require: "ngModel",
                             link: function (scope, elm, attrs, ngModel) {
                                 scope.$watch(attrs.ngModel, function (value) {
                                     var uniqueCodes = {};
                                     for (var i = 0; i < value.length; i++) {
                                         var underlying = value[i].code.substring(0, 3);
                                         uniqueCodes[underlying] = true;
                                     }

                                     ngModel.$setValidity("sameUnderlying", Object.keys(uniqueCodes).length == 1);
                                 });
                             }
                         };
                     })
                     .directive("legRatio", function () {
                         return {
                             require: "ngModel",
                             link: function (scope, elm, attrs, ngModel) {

                                 scope.$watch(attrs.ngModel, function (value) {
                                     var ratio = Math.abs(+value);
                                     var valid = ratio > 0 && ratio <= 4;
                                     ngModel.$setValidity("legRatio", valid);
                                 });
                             }
                         };
                     })
                     .filter("preset", function () {
                         return function (preset, points) {

                             if (preset.presetType == "%") {
                                 return "" +
                                     (preset.presetValue > 0 ? "+" : "") +
                                     (preset.presetValue * 100).toFixed(0) + "%";
                             } else if (preset.presetType == "$") {
                                 return "" +
                                     (preset.presetValue > 0 ? "+" : "") +
                                     (preset.presetValue).toFixed(2);
                             } else if (preset.presetType == "@") {
                                 return "@ " + (preset.presetValue).toFixed(points ? 1 : 3);
                             }
                             return "";
                         }
                     })
                     .controller("inviteClientCtrl", ["$scope", "$uibModalInstance", "linkedUsers", function ($scope, $uibModalInstance, linkedUsers) {
                         $scope.activeScenario = null;
                         $scope.linkedUsers = linkedUsers;
                         $scope.inviteInfo = {
                             name: "",
                             email: "",
                             acknowledge: false
                         };

                         $scope.ok = function () {
                             $uibModalInstance.close($scope.inviteInfo);
                         };

                         $scope.cancel = function () {
                             $uibModalInstance.dismiss();
                         }

                     }])
                     .controller("portfolioCtrl",
                         ["$scope", "$state", "$uibModal", "$stateParams", "$resource", "$timeout", "$interval", "$window", "$localStorage", "userConfig", "gridUtil", "uiGridConstants", "uiGridTreeBaseConstants", "uiGridExporterConstants", "uiGridGroupingConstants", "navSvc", "chainService", "terms", "$document", "newBusiness", "$filter", "$aside", "$http", "$q", "growl", "widgetPrefs", "confirmationService", "confirmationTypes", "tradefloorApi", "simpleModalService", "ticketService", "optionService", "strategyService", "screenSize", "placeOrderService", "companyService", "systemEventService", "collateralLodgingService", "ivSidebarService", "accountStore", "portfolioService", "clientEventService", "tmcListDialog",
                             function portfolioController($scope, $state, $uibModal, $stateParams, $resource, $timeout, $interval, $window, $localStorage, userConfig, gridUtil, uiGridConstants, uiGridTreeBaseConstants, uiGridExporterConstants, uiGridGroupingConstants, navSvc, chainService, terms, $document, newBusiness, $filter, $aside, $http, $q, growl, widgetPrefs, confirmationService, confirmationTypes, tradefloorApi, simpleModalService, ticketService, optionService, strategyService, screenSize, placeOrderService, companyService, systemEventService, collateralLodgingService, ivSidebarService, accountStore, portfolioService, clientEventService, tmcListDialog) {

                                 //SPECIFIC FOR TRADEON //

                                 $scope.gridContextMenu = [
                                     {
                                         html: `<a tabindex="-1" href="#"><i class="icon-circle-cross"></i> Close</a>`,
                                         click: function ($itemScope) {
                                             const selection = $scope.gridApi.selection.getSelectedGridRows();

                                             if (selection.length === 0) {
                                                 const clickedRow = $itemScope.row;

                                                 const position = clickedRow.entity;

                                                 if (position != null) {
                                                     $scope.gridApi.selection.selectRow(position);
                                                 }
                                             }

                                             $scope.closePositions()
                                         },
                                         enabled: function ($itemScope) {
                                             // const selectedRows = $scope.gridApi.selection.getSelectedGridRows();
                                             // return selectedRows.length > 0;
                                             return true;
                                         }
                                     },
                                     {
                                         html: `<a tabindex="-1" href="#"><i class="icon-share3"></i> Roll</a>`,
                                         click: function ($itemScope) {
                                             $scope.closeRollPositions();
                                         },
                                         enabled: function ($itemScope) {
                                             const selectedRows = $scope.gridApi.selection.getSelectedGridRows();
                                             return selectedRows.map((row) => row.entity)
                                                                .map((entity) => entity.type)
                                                                .some((type) => type === "PUT" || type === "CALL")
                                         }
                                     }
                                 ];

                                 $scope.payoff = {
                                     includeRealPositions: true
                                 };

                                 $scope.realignContent = function (isOpen) {
                                     $scope.quickWhatIfOpen = isOpen;
                                 };

                                 $scope.quickWhatIfService = new QuickWhatIfService();
                                 const quickWhatIfSubscription = $scope.quickWhatIfService.subscribe(p => {
                                     $scope.strategiesSidebarOpen = p != null;
                                     systemEventService.windowResize();
                                 });
                                 $scope.$on("$destroy", () => quickWhatIfSubscription.unsubscribe());

                                 const includeOptions = true;
                                 const includeEquities = userConfig.client != null || userConfig.strategyBasedView;

                                 const defaultPositionViewFilters = {
                                     positionViewFilters: {
                                         includeOptions: includeOptions,
                                         includeEquities: includeEquities
                                     }
                                 };

                                 $localStorage.$default(defaultPositionViewFilters);

                                 $scope.positionViewFilters = $localStorage.positionViewFilters;
                                 $scope.includeEquities = $scope.positionViewFilters.includeEquities;
                                 $scope.includeOptions = $scope.positionViewFilters.includeOptions;

                                 $scope.portfolioId = +$stateParams.portfolioId;

                                 accountStore.selectAccount($scope.portfolioId);
                                 $scope.sidebarOpen = null;

                                 const sidebarSubscription = ivSidebarService.onStateChange()
                                                                             .subscribe(open => $scope.sidebarOpen = open);
                                 $scope.$on("$destroy", () => sidebarSubscription.unsubscribe());

                                 let tableConfigKey;

                                 if (userConfig.strategyBasedView) {
                                     tableConfigKey = "gameTable";
                                 } else {
                                     tableConfigKey = "portfolioTable";
                                 }

                                 $scope.tradeStrategy = async (strategy) => {
                                     var portfolioType = $scope.portfolio.portfolioType;
                                     var isSimulated = portfolioType === "SIMULATED";
                                     var isBrokerOrderEnabled = (portfolioType === "BROKER" && userConfig.ordersEnabled);
                                     var isManual = portfolioType === "SCRATCH" || portfolioType === "LINKED";

                                     const strategyToTrade = ObjectUtil.copy(strategy);
                                     if (isManual) {
                                         if ($scope.activeWhatIf != null) {
                                             $scope.openNewBusiness($scope.activeWhatIf)
                                         } else {
                                             await calculateStrategySummary(strategyToTrade);
                                             $scope.openNewBusiness($scope.strategyToTrade)
                                         }
                                     } else {

                                         if (!strategy.tmc && strategy.trades.length > 1) {
                                             try {
                                                 await $scope.convertToTmc(strategyToTrade, true);
                                             } catch (e) {
                                                 await calculateStrategySummary(strategyToTrade);
                                             }
                                         } else {
                                             await calculateStrategySummary(strategyToTrade);
                                         }

                                         if (isSimulated || isBrokerOrderEnabled) {
                                             if ($scope.activeWhatIf != null) {
                                                 $scope.openTicket($scope.activeWhatIf)
                                             } else {
                                                 $scope.openTicket($scope.strategyToTrade);
                                             }
                                         }
                                     }
                                 };

                                 $scope.strategiesSidebarOpen = true;

                                 $scope.openStrategiesSideBar = () => {
                                     $scope.strategiesSidebarOpen = true;
                                     systemEventService.windowResize();
                                 };

                                 $scope.closeStrategiesSideBar = () => {
                                     $scope.strategiesSidebarOpen = false;
                                     systemEventService.windowResize();
                                 };

                                 $scope.toggleStrategiesBar = () => {
                                     $scope.strategiesSidebarOpen = !$scope.strategiesSidebarOpen;
                                     systemEventService.windowResize();
                                 };

                                 function selectBestCashBalanceChange() {
                                     if ($scope.activeScenario) {
                                         if ($scope.activeStrategy) {
                                             $scope.cashBalance.comparison = $scope.comparisons.CurrentVsStressedStrategy;
                                         } else {
                                             $scope.cashBalance.comparison = $scope.comparisons.CurrentVsStressed;
                                         }
                                     } else {
                                         if ($scope.activeStrategy) {
                                             $scope.cashBalance.comparison = $scope.comparisons.CurrentVsStrategy;
                                         } else {
                                             $scope.cashBalance.comparison = $scope.comparisons.ChangeOnDay;
                                         }
                                     }
                                 }

                                 $scope.comparisons = {};

                                 $scope.comparisons.CurrentVsStrategy = {
                                     name: "Current vs Strategy",
                                     columns: {
                                         eod: false,
                                         current: true,
                                         stressed: false,
                                         strategy: true
                                     }
                                 };

                                 $scope.comparisons.ChangeOnDay = {
                                     name: "Change on Day",
                                     columns: {
                                         eod: true,
                                         current: true,
                                         stressed: false,
                                         strategy: false
                                     }
                                 };

                                 $scope.comparisons.ChangeOnDayWithStrategy = {
                                     name: "Change on Day w/ strategy",
                                     columns: {
                                         eod: true,
                                         current: false,
                                         stressed: false,
                                         strategy: true
                                     }
                                 };

                                 $scope.comparisons.CurrentVsStressedStrategy = {
                                     name: "Current vs Stressed (with strategy)",
                                     columns: {
                                         eod: false,
                                         current: true,
                                         stressed: false,
                                         strategy: true
                                     }
                                 };

                                 $scope.comparisons.CurrentVsStressed = {
                                     name: "Current vs Stressed (without strategy)",
                                     columns: {
                                         eod: false,
                                         current: true,
                                         stressed: true,
                                         strategy: false
                                     }
                                 };

                                 $scope.cashBalance = {
                                     comparison: $scope.comparisons.ChangeOnDay
                                 };

                                 $scope.setComparison = function (comparison) {
                                     $scope.cashBalance.comparison = comparison;
                                 };

                                 $scope.toggleIncludeOptionPositions = function () {
                                     $scope.includeOptions = !$scope.includeOptions;

                                     $scope.positionViewFilters.includeOptions = $scope.includeOptions;
                                     $localStorage.positionViewFilters = $scope.positionViewFilters;

                                     $scope.updateGrid();
                                 };

                                 $scope.toggleIncludeEquityPositions = function () {
                                     $scope.includeEquities = !$scope.includeEquities;

                                     $scope.positionViewFilters.includeEquities = $scope.includeEquities;
                                     $localStorage.positionViewFilters = $scope.positionViewFilters;

                                     $scope.updateGrid();
                                 };

                                 $scope.widgetSrc = "payoffByExpiryTf.tpl.html";

                                 $scope.showPayoff = function () {
                                     $scope.widgetSrc = "payoffByExpiryTf.tpl.html";
                                 };

                                 $scope.showRiskArrays = function () {
                                     $scope.widgetSrc = "ra-portfolio.tpl.html";
                                 };

                                 $scope.showMarginSummary = function () {
                                     $scope.widgetSrc = "whatif.tpl.html";
                                 };

                                 $scope.showGreeks = function () {
                                     $scope.widgetSrc = "deltaAnalysis.tpl.html";
                                 };

                                 // TODO XXX Move this to a cookbook service
                                 $scope.openCookbook = function (underlying) {
                                     var modalInstance = $uibModal.open({
                                         templateUrl: "app/apps/optionsCookbook/optionsCookbook.tpl.html",
                                         controller: "optionsCookbookCtrl as optionsCookbookCtrl",
                                         size: "xl",
                                         resolve: {
                                             asAt: function () {
                                                 return null;
                                             },
                                             code: function () {
                                                 return underlying;
                                             },
                                             expiries: function () {
                                                 return chainService(underlying).then(function (chain) {
                                                     var expiries = [];
                                                     chain.series.filter(function (s) {
                                                         return moment().add(3, "days").isBefore(moment(s.expiry));
                                                     }).forEach(function (s) {
                                                         expiries.push({
                                                             expiry: s.expiry,
                                                             expiryType: s.expiryType
                                                         });
                                                     });
                                                     return expiries;
                                                 });
                                             }
                                         }
                                     });
                                     modalInstance.result.then(function (recipeParams) {
                                         $http.post("/tradefloor/api/strategy/kitchen", recipeParams).then(function (response) {
                                             var whatIfTrades = response.data;
                                             var whatIfName = underlying + " " + recipeParams.longName;

                                             $scope.svcCreateWhatIf(whatIfName, whatIfTrades).then(function (w) {
                                                 $timeout(function () {
                                                     $scope.$broadcast("whatif.flushed");
                                                     $scope.setActiveWhatIf(w);
                                                 }, 0)
                                             });
                                         });
                                     }, function () {
                                     });
                                 };

                                 function barColour(percent) {
                                     percent = Math.min(percent, 1);
                                     return "hsl(" + Math.round(120 * (1 - percent)) + ", 70%, 45%)";
                                 }

                                 $scope.singleUnderlying = true;

                                 $scope.sortType = "code";
                                 $scope.sortReverse = false;

                                 $scope.toggleTradeActivitySort = function (sortType) {
                                     if ($scope.sortType === sortType) {
                                         $scope.sortReverse = !$scope.sortReverse;
                                     } else {
                                         $scope.sortType = sortType;
                                         $scope.sortReverse = false;
                                     }
                                 };

                                 $scope.sortTodayType = "code";
                                 $scope.sortTodayReverse = false;

                                 $scope.toggleTodayTradeActivitySort = function (sortType) {
                                     if ($scope.sortTodayType === sortType) {
                                         $scope.sortTodayReverse = !$scope.sortTodayReverse;
                                     } else {
                                         $scope.sortTodayType = sortType;
                                         $scope.sortTodayReverse = false;
                                     }
                                 };

                                 $scope.searchTrades = "";

                                 var Positions = $resource("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/positions", {});
                                 var WhatIfs = $resource("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs", {});

                                 var marginMultiplier = null;
                                 var limitMultiplier = null;
                                 var marginSchedule = null;
                                 var etoBrokerageSchedule = null;
                                 var lepoBrokerageSchedule = null;
                                 var equityBrokerageSchedule = null;
                                 var scratch = false;
                                 var equityLedger = null;
                                 var etoLedger = null;
                                 var cmBalance = null;
                                 var eodMargin = null;
                                 var currentPositions = null;
                                 var equityPositions = null;
                                 var cachedOptionService = null;
                                 var lastUnderlying = null;

                                 $scope.cardFlippedMargin = false;
                                 $scope.cardFlippedCash = false;

                                 $scope.unlimitedWhatIfs = userConfig.features["FEATURE_UNLIMITED_WHAT_IF"];
                                 $scope.canPlaceOrders = userConfig.ordersEnabled;
                                 $scope.canShare = userConfig.features["FEATURE_SHARE"] === true;
                                 $scope.optionPositions = userConfig.features["FEATURE_OPTION_POSITIONS"] === true;
                                 $scope.advancedStressTesting = userConfig.features["FEATURE_PF_STRESS_TEST"] === true || userConfig.features["FEATURE_PF_STRESS_TEST_LIMITED"] === true;
                                 $scope.simpleStressTesting = !userConfig.features["FEATURE_PF_STRESS_TEST"] && (userConfig.broker === "TC");

                                 var reloadMarginsTimeout = null;

                                 var pendingWhatIfUpdates = {};
                                 var pendingWhatIfUpdateTimeout = null;
                                 var pendingWhatIfUpdateLastFlush = new Date();

                                 var whatIfRefreshTimer = null;

                                 function startWhatIfRefresh(whatIf) {
                                     stopWhatIfRefresh(); // just in case

                                     whatIfRefreshTimer = $interval(function () {
                                         $http.get("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + whatIf.id + "?updated=" + encodeURIComponent(whatIf.lastUpdated))
                                              .then(function (response) {
                                                  var data = response.data;
                                                  if (response.status === 200) {
                                                      whatIf.lastUpdated = data.lastUpdated;
                                                      whatIf.trades = data.trades;
                                                      whatIf.name = data.name;

                                                      broadcastWhatIfChange(whatIf);

                                                      reloadMarginsNow();
                                                  }
                                              });
                                     }, 5000);

                                 }

                                 function stopWhatIfRefresh() {
                                     if (whatIfRefreshTimer) {
                                         $interval.cancel(whatIfRefreshTimer);
                                         whatIfRefreshTimer = null;
                                     }
                                 }

                                 function clearPendingWhatIfUpdates() {
                                     pendingWhatIfUpdates = null;
                                     if (pendingWhatIfUpdateTimeout) {
                                         $timeout.cancel(pendingWhatIfUpdates);
                                         pendingWhatIfUpdateTimeout = null;
                                     }
                                     pendingWhatIfUpdateLastFlush = new Date();
                                 }

                                 function flushPendingWhatIfUpdates() {
                                     var deferred = $q.defer();

                                     if (pendingWhatIfUpdateTimeout) {
                                         $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + $scope.activeWhatIf.id + "/trades", $scope.activeWhatIf.trades)
                                              .then(function () {
                                                  $scope.$broadcast("whatif.flushed");
                                                  deferred.resolve();
                                              });

                                         pendingWhatIfUpdateLastFlush = new Date();
                                         pendingWhatIfUpdateTimeout = null;

                                     } else {
                                         deferred.resolve();
                                     }

                                     return deferred.promise;
                                 }

                                 function queueWhatIfUpdate() {

                                     if (pendingWhatIfUpdateTimeout) {
                                         // Flush out all pending changes if it has been a while since we have flushed changes
                                         // This guarantees a safe point every x seconds
                                         if (new Date().getTime() - pendingWhatIfUpdateLastFlush.getTime() > 20000) {
                                             $timeout.cancel(pendingWhatIfUpdateTimeout);
                                             flushPendingWhatIfUpdates();
                                         }
                                     } else {
                                         // First change of a batch
                                         pendingWhatIfUpdateTimeout = $timeout(flushPendingWhatIfUpdates, 3000);
                                     }
                                     broadcastWhatIfChange($scope.activeWhatIf);
                                 }

                                 function loadTradeHistory() {
                                     return $http.get("/tradefloor/api/trade/" + $stateParams.portfolioId)
                                                 .then(function (response) {
                                                     var data = response.data;
                                                     $scope.trades = data;
                                                 });
                                 }

                                 $scope.companies = null;

                                 $scope.findCompanies = async function (input) {
                                     if ($scope.companies == null) {
                                         $scope.companies = await companyService.companies(true);
                                     }
                                     return companyService.findCompanies($scope.companies, input);
                                 };


                                 $scope.equityTrades = [];

                                 $scope.updateWhatIfCollateral = function () {
                                     $scope.equityTrades = [];
                                     if ($scope.equityCollateralFormData.issuer && $scope.equityCollateralFormData.quantity) {
                                         var equityTrade = {
                                             issuer: $scope.equityCollateralFormData.issuer.code,
                                             quantity: $scope.equityCollateralFormData.quantity
                                         };
                                         $scope.equityTrades.push(equityTrade);
                                         reloadMarginsNow();
                                     }
                                 };

                                 $scope.calculateAvailableWidgetHeight = function (gridsterItem) {
                                     return gridsterItem.getElementSizeY() - 50 - 32;
                                 };


                                 var widgetTcPayoffByExpiry = {
                                     name: "tcPayoffByExpiry",
                                     feature: "WIDGET_TC_PAYOFF",
                                     templateSrc: "app/portfolio/widgets/custom/traderscircle/payoffByExpiry.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Payoffs by Expiry",
                                     cost: "free"
                                 };

                                 var widgetTcPayoffDetail = {
                                     name: "tcPayoffDetail",
                                     feature: "WIDGET_TC_PAYOFF",
                                     templateSrc: "app/portfolio/widgets/custom/traderscircle/payoffDetail.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Payoffs by Expiry",
                                     cost: "free"
                                 };

                                 var widgetTfPayoffByExpiry = {
                                     name: "tfPayoffByExpiry",
                                     feature: "WIDGET_TF_PAYOFF",
                                     templateSrc: "app/portfolio/widgets/payoffByExpiryTf.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Payoffs by Expiry",
                                     cost: "free"
                                 };

                                 var widgetWhatIf = {
                                     name: "whatif",
                                     feature: "WIDGET_WHAT_IF",
                                     templateSrc: "app/portfolio/widgets/whatif.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "What If Analysis",
                                     cost: "free"
                                 };

                                 var widgetDeltaAnalysis = {
                                     name: "deltaAnalysis",
                                     feature: "WIDGET_DELTA_ANALYSIS",
                                     templateSrc: "app/portfolio/widgets/deltaAnalysis.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Delta Analysis",
                                     cost: "free"
                                 };

                                 var widgetRaPortfolio = {
                                     name: "ra-portfolio",
                                     feature: "WIDGET_RA_PORTFOLIO",
                                     templateSrc: "app/portfolio/widgets/ra-portfolio.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 8,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Risk Array - Portfolio",
                                     cost: "free"
                                 };

                                 var widgetRaSecurity = {
                                     name: "ra-security",
                                     feature: "WIDGET_RA_SECURITY",
                                     templateSrc: "app/portfolio/widgets/ra-security.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 8,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Risk Array - Secutiry",
                                     cost: "free"
                                 };

                                 var widgetIcConcessions = {
                                     name: "icConcessions",
                                     feature: "WIDGET_IC",
                                     templateSrc: "app/portfolio/widgets/icConcessions.tpl.html",
                                     minSizeX: 2,
                                     sizeX: 2,
                                     maxSizeX: 2,
                                     minSizeY: 12,
                                     sizeY: 12,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Inter Commodity Concession Analysis",
                                     cost: "free"
                                 };

                                 var widgetBreakdowns = {
                                     name: "breakdowns",
                                     feature: "WIDGET_SECURITY_BREAKDOWN",
                                     templateSrc: "app/portfolio/widgets/breakdowns.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 2,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 8,
                                     maxSizeY: 14,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "Security Breakdown",
                                     cost: "free"
                                 };

                                 var widgetWhatIfComparison = {
                                     name: "whatIfComparison",
                                     feature: "WIDGET_WHAT_IF_COMPARISON",
                                     templateSrc: "app/portfolio/widgets/whatIfComparison.tpl.html",
                                     minSizeX: 1,
                                     sizeX: 1,
                                     maxSizeX: 2,
                                     minSizeY: 6,
                                     sizeY: 10,
                                     maxSizeY: 20,
                                     image: null,
                                     description: "",
                                     rating: 0,
                                     title: "WhatIf Comparison",
                                     cost: "free"
                                 };

                                 // TODO this should live in the widget service
                                 var allWidgets = [
                                     widgetTfPayoffByExpiry,
                                     widgetWhatIfComparison,

                                     widgetWhatIf,
                                     widgetDeltaAnalysis,

                                     widgetRaPortfolio,
                                     widgetRaSecurity,

                                     widgetIcConcessions,
                                     widgetBreakdowns,

                                     widgetTcPayoffByExpiry,
                                     widgetTcPayoffDetail
                                 ];

                                 var widgetsByName = {};

                                 allWidgets.forEach(function (w) {
                                     widgetsByName[w.name] = w;
                                 });

                                 var tcWidgets = [
                                     widgetTcPayoffByExpiry,
                                     widgetTcPayoffDetail
                                 ];

                                 var tcWidgetsByName = {};

                                 tcWidgets.forEach(function (w) {
                                     tcWidgetsByName[w.name] = w;
                                 });


                                 // Find all widgets user has paid for or are free
                                 // this is just a candidate list that will be merged with the saved layout to build the grid
                                 // TODO this would live in the widget service
                                 $scope.availableUserWidgets = allWidgets.filter(function (w) {

                                     if (userConfig.features[w.feature]) {
                                         return true;
                                     }

                                     // Always show TC widgets even if they don't have access
                                     if (userConfig.branding === "TC" && tcWidgetsByName[w.name]) {
                                         return true;
                                     }

                                     return false;
                                 });

                                 function sortPrefsByPosition(a, b) {
                                     if (a.row < b.row) {
                                         return -1;
                                     }

                                     if (a.row > b.row) {
                                         return 1;
                                     }

                                     if (a.col < b.col) {
                                         return -1;
                                     }

                                     if (a.col > b.col) {
                                         return 1;
                                     }

                                     return 0;
                                 }

                                 $scope.widgets = [];
                                 widgetPrefs.getPreference([]).then(function (prefs) {
                                     var currentX = 0;
                                     var currentY = 0;
                                     var maxRowHeight = 0;

                                     var widgetsToAdd = $scope.availableUserWidgets.map(function (w) {
                                         return w;
                                     });

                                     var newPrefs = prefs.filter(function (w) {
                                         var widgetDef = widgetsByName[w.name];
                                         if (!widgetDef) {
                                             return false;
                                         }
                                         return userConfig.features[widgetDef.feature] || false;
                                     })
                                                         .sort(sortPrefsByPosition);

                                     newPrefs.forEach(function (w) {

                                         if (currentY !== w.row) {
                                             maxRowHeight = 0;
                                         }

                                         currentX = w.col;
                                         currentY = w.row;

                                         maxRowHeight = Math.max(maxRowHeight, w.sizeY);


                                         // remove the widget we just added
                                         widgetsToAdd = widgetsToAdd.filter(function (w1) {
                                             return w1.name !== w.name;
                                         })
                                     });

                                     widgetsToAdd.forEach(function (w) {

                                         // TODO move the hard coded 2 out somewhere else
                                         // move to the next line if there isn't enough space
                                         if (currentX !== 0 && currentX + w.sizeX > 2) {
                                             currentX = 0;
                                             currentY += maxRowHeight;
                                             maxRowHeight = 0;
                                         }

                                         newPrefs.unshift({
                                             name: w.name,
                                             // Default size from definition
                                             sizeX: w.sizeX,
                                             sizeY: w.sizeY,
                                             col: currentX,
                                             row: currentY
                                         });

                                         currentX += w.sizeX;
                                         maxRowHeight = Math.max(maxRowHeight, w.sizeY);
                                     });


                                     // Convert saved widgets to grid widgets
                                     $scope.widgets = newPrefs.map(function (w) {
                                         var widgetDef = widgetsByName[w.name];

                                         return {
                                             name: widgetDef.name,
                                             src: widgetDef.templateSrc,

                                             row: w.row,
                                             col: w.col,

                                             minSizeX: widgetDef.minSizeX,
                                             sizeX: w.sizeX,
                                             maxSizeX: widgetDef.maxSizeX,

                                             minSizeY: widgetDef.minSizeY,
                                             sizeY: w.sizeY,
                                             maxSizeY: widgetDef.maxSizeY
                                         };


                                     });


                                     $scope.saveWidgetLayout = function () {
                                         widgetPrefs.getPreference([])
                                                    .then(function (oldPrefValue) {
                                                        var newPrefValue = $scope.widgets.map(function (w) {
                                                            return {
                                                                name: w.name,
                                                                row: w.row,
                                                                col: w.col,
                                                                sizeX: w.sizeX,
                                                                sizeY: w.sizeY
                                                            };
                                                        });

                                                        newPrefValue.sort(sortPrefsByPosition);


                                                        if (!angular.equals(oldPrefValue, newPrefValue)) {
                                                            widgetPrefs.setPreference(newPrefValue);
                                                        }
                                                    });
                                     };

                                     // Save in case we have added or removed something
                                     $scope.saveWidgetLayout();
                                 });

                                 $scope.gridsterOpts = {
                                     columns: 2, // the width of the grid, in columns
                                     pushing: true, // whether to push other items out of the way on move or resize
                                     floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                                     swapping: true, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                                     width: "auto", // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                                     colWidth: "auto", // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                                     rowHeight: 50, // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                                     margins: [10, 10], // the pixel distance between each widget
                                     outerMargin: false, // whether margins apply to outer edges of the grid
                                     isMobile: true, // stacks the grid items if true
                                     mobileBreakPoint: 1024, // if the screen is not wider that this, remove the grid layout and stack the items
                                     mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                                     minColumns: 1, // the minimum columns the grid must have
                                     minRows: 2, // the minimum height of the grid, in rows
                                     maxRows: 100,
                                     defaultSizeX: 1, // the default width of a gridster item, if not specifed
                                     defaultSizeY: 1, // the default height of a gridster item, if not specified
                                     minSizeX: 1, // minimum column width of an item
                                     maxSizeX: null, // maximum column width of an item
                                     minSizeY: 1, // minumum row height of an item
                                     maxSizeY: null, // maximum row height of an item
                                     resizable: {
                                         enabled: true,
                                         handles: ["s", "e", "w"],
                                         start: function (event, $element, widget) {
                                         }, // optional callback fired when resize is started,
                                         resize: function (event, $element, widget) {
                                         }, // optional callback fired when item is resized,
                                         stop: function (event, $element, widget) {
                                             $scope.saveWidgetLayout();
                                             $scope.$broadcast("gridster-item-resized-stop", widget);
                                         } // optional callback fired when item is finished resizing
                                     },
                                     draggable: {
                                         enabled: false, // whether dragging items is supported
                                         handle: ".moveable", // optional selector for resize handle
                                         start: function (event, $element, widget) {
                                         }, // optional callback fired when drag is started,
                                         drag: function (event, $element, widget) {
                                         }, // optional callback fired when item is moved,
                                         stop: function (event, $element, widget) {
                                             $scope.saveWidgetLayout();
                                         } // optional callback fired when item is finished dragging
                                     }
                                 };

                                 // HACK to get grips working correctly. Has to run after templates are loaded, but we don't know when that is, so 2 seconds is good enough
                                 $timeout(function () {
                                     $scope.gridsterOpts.draggable.enabled = true;
                                 }, 2000);


                                 $scope.cashCollateralFormData = {
                                     issuer: "",
                                     value: 0
                                 };

                                 $scope.equityCollateralFormData = {
                                     issuer: null,
                                     isValid: true
                                 };

                                 $scope.terms = terms;
                                 $scope.navSvc = navSvc;

                                 $scope.prices = {};

                                 $scope.isshowScenarios = false;
                                 var defaultStorage = {};
                                 defaultStorage.showClosedPositions = false;
                                 defaultStorage.portfolioClientMargin = true;

                                 defaultStorage.portfolioTour = {
                                     complete: false,
                                     skipped: false
                                 };

                                 defaultStorage.portfolioTable = {
                                     version: 1
                                 };

                                 defaultStorage.gameTable = {
                                     version: 1
                                 };


                                 var portfolioPrefsKey = "portfolioPrefs_" + $stateParams.portfolioId;
                                 defaultStorage.selectedScenario = undefined;
                                 defaultStorage[portfolioPrefsKey] = {
                                     activeWhatIf: null,
                                     selectedTab: "WhatIf",
                                     fullScreenOpenPos: true
                                 };

                                 $scope.$storage = $localStorage.$default(defaultStorage);

                                 $scope.whatIfTabs = {
                                     activeIndex: $scope.$storage[portfolioPrefsKey].selectedTab
                                 };

                                 if ($stateParams.activeWhatIfId) {
                                     $scope.whatIfTabs.activeIndex = "WhatIf" + $stateParams.activeWhatIfId;
                                     $scope.$storage[portfolioPrefsKey].selectedTab = "WhatIf" + $stateParams.activeWhatIfId;
                                     $scope.$storage[portfolioPrefsKey].activeWhatIf = $stateParams.activeWhatIfId;
                                 }

                                 // Migrating legacy whatifs storage
                                 if ($scope.whatIfTabs.activeIndex === "WhatIf") {
                                     if ($scope.$storage[portfolioPrefsKey].activeWhatIf) {
                                         $scope.whatIfTabs.activeIndex = "WhatIf" + $scope.$storage[portfolioPrefsKey].activeWhatIf;
                                     }
                                 }

                                 $scope.activeStrategyId = null;

                                 if ($stateParams.activeStrategyId != null) {
                                     $scope.activeStrategyId = $stateParams.activeStrategyId;
                                 }

                                 $scope.fullScreenOpenPos = $localStorage[portfolioPrefsKey].fullScreenOpenPos || false;
                                 $scope.isStockCollapsed = true;
                                 $scope.isMarketCollapsed = true;
                                 $scope.isTimeCollapsed = true;

                                 $scope.modified = $filter("modified");
                                 $scope.dateFilter = $filter("date");
                                 $scope.numberFilter = $filter("number");

                                 $scope.timeDecayScenario = {
                                     name: "As at EOD",
                                     marketScenario: undefined,
                                     asAt: undefined,
                                     selectedDate: null,
                                     isOpen: false
                                 };

                                 $scope.nextIndexExpiryScenario = {
                                     name: "Index Expiry",
                                     marketScenario: undefined,
                                     asAt: undefined
                                 };

                                 $scope.nextEtoExpiryScenario = {
                                     name: "ETO Expiry",
                                     marketScenario: undefined,
                                     asAt: undefined
                                 };

                                 $scope.timeParams = {
                                     collapsed: true,
                                     scenarios: [],
                                     activeScenario: null
                                 };


                                 $scope.eodRecalculatedAsx = {
                                     name: "Recalculated EOD ASX",
                                     marketScenario: {},
                                     modelType: "E",
                                     asAt: undefined
                                 };

                                 $scope.latestRecalculatedAsx = {
                                     name: "Recalculated Current ASX",
                                     marketScenario: {},
                                     modelType: "I",
                                     asAt: undefined
                                 };

                                 $scope.latestAsx = {
                                     name: "Latest ASX",
                                     modelType: "I",
                                     marketScenario: null,
                                     asAt: undefined
                                 };

                                 $scope.latestUpdatedAsx = {
                                     name: "Latest ASX Updated Params",
                                     modelType: "XI",
                                     marketScenario: null,
                                     asAt: undefined
                                 };


                                 $scope.eodUpdatedAsx = {
                                     name: "Updated Params (EOD)",
                                     modelType: "X",
                                     marketScenario: null,
                                     asAt: undefined
                                 };

                                 $scope.eodAsx = {
                                     name: "End of Day (EOD)",
                                     modelType: "E",
                                     marketScenario: null,
                                     asAt: undefined
                                 };

                                 $scope.stockParams = {
                                     stocks: []
                                 };

                                 function createDefaultPricePresets() {
                                     return {
                                         up: [
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.15
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.10
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.05
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.02
                                             }
                                         ],
                                         down: [
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.15
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.10
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.05
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.02
                                             }
                                         ],
                                         minIncrements: [
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.01
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.02
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.03
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.04
                                             }
                                         ]
                                     };
                                 }

                                 function createDefaultVolPresets() {
                                     return {
                                         up: [
                                             {
                                                 presetType: "%",
                                                 presetValue: 1
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.5
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.2
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: 0.1
                                             }
                                         ],
                                         down: [
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.75
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.5
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.2
                                             },
                                             {
                                                 presetType: "%",
                                                 presetValue: -0.1
                                             }
                                         ]
                                     };
                                 }

                                 $scope.toggleClientMargin = function () {
                                     $scope.$storage.portfolioClientMargin = !$scope.$storage.portfolioClientMargin;

                                     reloadMarginsNow();
                                 };


                                 $scope.toggleStock = function (stock) {
                                     stock.collapsed = !stock.collapsed;

                                     if (!stock.collapsed) {
                                         $scope.stockParams.stocks.forEach(function (s) {
                                             if (s !== stock) {
                                                 s.collapsed = true;
                                             }
                                         });
                                     }
                                 };

                                 $scope.currentActive = {
                                     collateral: true,
                                     activity: false
                                 };
                                 $scope.newBusiness = null;
                                 $scope.portfolioEquityCollateral = [];
                                 $scope.portfolioCashCollateral = [];
                                 $scope.totalNewBusiness = 0;
                                 $scope.systemNewBusinessPositions = [];
                                 $scope.manualNewBusinessPositions = [];

                                 $scope.dropzoneConfig = {
                                     "options": { // passed into the Dropzone constructor
                                         "url": "/tradefloor/api/upload/" + $stateParams.portfolioId + "/positions"
                                     },
                                     "eventHandlers": {
                                         "sending": function (file, formData, xhr) {
                                         },
                                         "success": function (file, trades) {
                                             if (!trades.length) {
                                                 return;
                                             }

                                             flushPendingWhatIfUpdates().then(function () {
                                                 var persistPromise;
                                                 var whatIfTrades = trades.map(function (t) {
                                                         return {
                                                             code: t.c,
                                                             quantity: t.q
                                                         };
                                                     }
                                                 );

                                                 if ($scope.unlimitedWhatIfs) {
                                                     persistPromise = $scope.svcCreateWhatIf($scope.suffixWhatIfName("Uploaded Strategy"), whatIfTrades).then(function (whatIf) {
                                                         $timeout(function () {
                                                             $scope.$broadcast("whatif.flushed");
                                                             $scope.setActiveWhatIf(whatIf);
                                                         }, 0);

                                                     });
                                                 } else {
                                                     persistPromise = $scope.svcUpdateWhatIfTrades($scope.activeWhatIf, whatIfTrades);
                                                 }

                                                 persistPromise.then(function () {
                                                     $scope.isCollapsedUploader = false;
                                                     reloadMarginsNow();
                                                 });
                                             });
                                         }
                                         ,
                                         "dragstart": function () {
                                             $scope.showUploader();
                                         }
                                     }
                                 };

                                 $scope.showUploader = function () {
                                     $scope.isCollapsedUploader = !$scope.isCollapsedUploader;
//                $scope.$emit('widget.collapsed', $scope.isCollapsedUploader);
                                 };

                                 $scope.portfolio = null;

                                 $scope.historicalMarginData = [];
                                 $scope.historicalExcessData = [];

                                 $scope.whatIfTotals = {
                                     netDelta: 0,
                                     dollarDelta: 0,
                                     premium: 0,
                                     marginEffect: 0,
                                     theo: 0

                                 };

                                 $scope.changeSummary = {
                                     costOfTrade: 0,
                                     changeInMargin: 0,
                                     netEffect: 0,
                                     currentShortage: 0,
                                     whatIfShortage: 0,
                                     changeInScan: 0,
                                     addMargin: 0,
                                     changeInIC: 0,
                                     lepoMtm: 0,
                                     utilisation: 0,
                                     utilisationPct: 0,
                                     utilisationClamped: 0,
                                     utilisationLevel: null
                                 };
                                 $scope.marginSummary = {};

                                 $scope.totalEquityCollateral = 0;
                                 $scope.totalCashCollateral = 0;

                                 $scope.dropzoneListeners = {
                                     dragstart: function () {
                                         $scope.dragging = true;
                                     },
                                     dragend: function () {
                                         $scope.dragging = false;
                                     }
                                 };

                                 $scope.whatIfs = [];
                                 $scope.whatIfsLoaded = false;

                                 $scope.exportCsv = function () {
                                     $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
                                 };

                                 $scope.exportCsvVisible = function () {
                                     $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.VISIBLE);
                                 };

                                 function saveTablePreferences() {
                                     $timeout(function () {
                                         if (!$scope.gridApi) {
                                             return;
                                         }

                                         const data = $scope.gridApi.saveState.save();
                                         delete data.grouping;

                                         $scope.$storage[tableConfigKey] = {
                                             version: 1,
                                             data
                                         }
                                     });
                                 }

                                 const destroyed$ = new ReplaySubject(1);

                                 $scope.$on("$destroy", () => {
                                     destroyed$.next(true);
                                     destroyed$.complete();
                                 });

                                 clientEventService.events()
                                                   .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                                   .takeUntil(destroyed$)
                                                   .subscribe(() => reloadMarginsDeferred());

                                 clientEventService.events()
                                                   .takeUntil(destroyed$)
                                                   .filter(isPortfoliosUpdatedClientEvent)
                                                   .map((event) => event.portfolioId)
                                                   .filter((pid) => $stateParams.portfolioId === pid)
                                                   .subscribe(() => loadPortfolio(false));

                                 const orderEvents = [ClientEventType.ORDER_UPDATED, ClientEventType.ORDER_COMPLETED];

                                 clientEventService.events()
                                                   .takeUntil(destroyed$)
                                                   .filter(isOrderClientEvent)
                                                   .filter((evt) => orderEvents.includes(evt.type))
                                                   .map((event) => event.portfolioId)
                                                   .filter((pid) => $stateParams.portfolioId === pid)
                                                   .subscribe(() => loadPortfolio(false));

                                 $scope.$on("position.table.preset", function (event, preset) {
                                     $scope.gridApi.grid.getColumn(preset.filterColumn).filters[0].term = preset.filterTerm;

                                     var sortColumn = $scope.gridApi.grid.getColumn(preset.sortColumn);

                                     $scope.gridApi.grid.sortColumn(sortColumn, preset.ascending ? uiGridConstants.ASC : uiGridConstants.DESC, false);
                                 });

                                 // TODO hack to get visibiilty changes saving until there is a callback to trigger it
                                 $scope.$on("$destroy", function () {
                                     flushPendingWhatIfUpdates();
                                     stopWhatIfRefresh();
                                     saveTablePreferences();
                                 });

                                 $scope.createPosition = {
                                     quantity: null,
                                     instrument: null
                                 };

                                 $scope.$on("whatif.active.change", function updateActive(event, whatIfId) {
                                     $scope.whatIfs.forEach(function (w) {
                                         if (w.id === whatIfId) {
                                             $scope.setActiveWhatIf(w);
                                         }
                                     })
                                 });

                                 $scope.setActiveWhatIf = function (whatIf, form) {
                                     if ($scope.activeWhatIf !== whatIf) {
                                         if ($scope.gridApi) {
                                             $scope.gridApi.selection.clearSelectedRows();
                                         }
                                         if ($scope.whatIfsLoaded) {
                                             $localStorage[portfolioPrefsKey].selectedTab = "WhatIf" + whatIf.id;
                                             $localStorage[portfolioPrefsKey].activeWhatIf = whatIf.id;
                                             $scope.whatIfTabs.activeIndex = "WhatIf" + whatIf.id;
                                         }
                                         flushPendingWhatIfUpdates();

                                         clearCreateWhatIfTrade(form);

                                         $scope.activeWhatIf = whatIf;

                                         if (currentPositions != null) {
                                             reloadMarginsNow()
                                         }

                                         if (whatIf.shared && !whatIf.mine) {
                                             startWhatIfRefresh(whatIf);
                                         } else {
                                             stopWhatIfRefresh();
                                         }
                                         broadcastWhatIfChange(whatIf);
                                     }
                                 };

                                 $scope.setupActiveScenario = function () {

                                     $scope.activeScenario = {
                                         name: "Stressed",
                                         enabled: false,
                                         marketScenario: null,
                                         securityScenarios: [],
                                         sectorScenarios: []
                                     };

                                     if ($scope.marketParams.enabled) {
                                         $scope.activeScenario.enabled = true;
                                         $scope.activeScenario.marketScenario = {
                                             vol: $scope.marketParams.vol,
                                             price: $scope.marketParams.price,
                                             priceType: $scope.marketParams.priceType
                                         }
                                     }


                                     $scope.activeScenario.securityScenarios = $scope.stockParams.stocks.filter(function (s) {
                                         return s.enabled;
                                     }).map(function (s) {
                                         return {
                                             vol: s.vol,
                                             price: s.price,
                                             priceType: s.priceType,
                                             security: s.security
                                         };
                                     });

                                     if ($scope.activeScenario.securityScenarios.length > 0) {
                                         $scope.activeScenario.enabled = true;
                                     }


                                     if ($scope.timeParams.enabled) {
                                         $scope.activeScenario.enabled = true;
                                         $scope.activeScenario.asAt = $scope.timeParams.activeScenario.asAt;
                                         $scope.activeScenario.modelType = $scope.timeParams.activeScenario.modelType;

                                         if ($scope.timeParams.activeScenario.marketScenario && !$scope.activeScenario.marketScenario) {
                                             $scope.activeScenario.marketScenario = $scope.timeParams.activeScenario.marketScenario;
                                         }
                                     }

                                     if (!$scope.activeScenario.enabled) {
                                         $scope.activeScenario = null;
                                     }

                                     selectBestCashBalanceChange();
                                 };

                                 $scope.selectCustomPriceType = function (scenario, priceType) {
                                     scenario.priceType = priceType;
                                     scenario.customPriceType = priceType;
                                     if (priceType === "%") {
                                         scenario.customPrice = 0;
                                     } else if (priceType === "$") {
                                         scenario.customPrice = 0;
                                     } else {
                                         // We won't have a price if you are doing a what if on a new security
                                         // we could return an empty combined commodity record and fitler it out later
                                         scenario.customPrice = (scenario.security === "Market" ? $scope.xjoPrice : $scope.prices[scenario.security]) || 0;
                                     }

                                     $scope.setCustomPrice(scenario, scenario.customPrice);
                                 };

                                 $scope.setCustomPrice = function (scenario, price) {
                                     price = +price;
                                     scenario.customPrice = price;

                                     // in case we switch from preset to custom
                                     scenario.priceType = scenario.customPriceType;

                                     // TODO we could remove this if we left everything in pre scaled numbers and scaled it when converting to a scenario
                                     if (scenario.priceType === "%") {
                                         scenario.price = price / 100;
                                     } else {
                                         scenario.price = price;
                                     }
                                     scenario.activePricePreset = null;


                                     $scope.updateScenarioEnablement(scenario);
                                     $scope.runScenario();
                                 };

                                 $scope.selectPresetPrice = function (scenario, preset) {

                                     if (scenario.activePricePreset === preset) {
                                         scenario.price = 0;
                                         scenario.priceType = "%";
                                         scenario.activePricePreset = null;
                                     } else {
                                         scenario.price = preset.presetValue;
                                         scenario.priceType = preset.presetType;
                                         scenario.activePricePreset = preset;
                                     }

                                     $scope.updateScenarioEnablement(scenario);
                                     $scope.runScenario();

                                 };

                                 $scope.setCustomVol = function (scenario, vol) {
                                     vol = +vol;

                                     scenario.vol = vol / 100;

                                     scenario.activeVolPreset = null;

                                     scenario.enabled = (scenario.vol || scenario.price) !== 0;

                                     $scope.updateScenarioEnablement(scenario);
                                     $scope.runScenario();
                                 };

                                 $scope.selectPresetVol = function (scenario, preset) {

                                     if (scenario.activeVolPreset === preset) {
                                         scenario.vol = 0;
                                         scenario.volType = "%";
                                         scenario.activeVolPreset = null;
                                     } else {
                                         scenario.vol = preset.presetValue;
                                         scenario.volType = preset.presetType;
                                         scenario.activeVolPreset = preset;
                                     }

                                     $scope.updateScenarioEnablement(scenario);
                                     $scope.runScenario();
                                 };

                                 $scope.toggleTimeScenario = function () {
                                     if ($scope.timeParams.enabled) {
                                         $scope.timeParams.enabled = true;
                                         $scope.runScenario();
                                     } else {
                                         // $scope.timeParams.activeScenario = null;
                                         $scope.timeParams.enabled = false;
                                         $scope.runScenario();
                                     }
                                 };

                                 $scope.selectTimeScenario = function (scenario) {
                                     if ($scope.timeParams.activeScenario === scenario) {
                                         $scope.timeParams.activeScenario = null;
                                         $scope.timeParams.enabled = false;
                                     } else {
                                         $scope.timeParams.activeScenario = scenario;
                                         $scope.timeParams.enabled = true;
                                     }

                                     $scope.runScenario();
                                 };

                                 $scope.updateScenarioEnablement = function (scenario) {
                                     scenario.enabled = (scenario.vol || scenario.price) !== 0;

                                 };

                                 $scope.runScenario = function (stock) {
                                     if (stock) {
                                         if (stock.enabled) {
                                             stock.collapsed = false;
                                         }
                                         if (!stock.collapsed) {
                                             $scope.stockParams.stocks.forEach(function (s) {
                                                 if (s !== stock) {
                                                     s.collapsed = true;
                                                 }
                                             });
                                         }
                                     }

                                     $scope.setupActiveScenario();
                                     $scope.$broadcast("stress.scenario.change", $scope.activeScenario);

                                 };

                                 $scope.$on("stress.scenario.change", function (scenario) {
                                     reloadMarginsNow();
                                 });

                                 $scope.selectCurrent = function (tab) {

                                     if ($scope.whatIfsLoaded) {
                                         $localStorage[portfolioPrefsKey].selectedTab = tab;
                                         $localStorage[portfolioPrefsKey].activeWhatIf = null;
                                         $scope.whatIfTabs.activeIndex = tab;
                                     }
                                     if ($scope.activeWhatIf != null) {
                                         flushPendingWhatIfUpdates();
                                         $scope.activeWhatIf = null;
                                     }

                                     if (currentPositions != null) {
                                         reloadMargins(true);
                                         broadcastWhatIfChange(null);
                                     }

                                     if (tab === "TradeHistory") {
                                         loadTradeHistory();
                                     }
                                 };

                                 $scope.pinWhatIf = function (whatIf) {
                                     whatIf.pinned = !whatIf.pinned;
                                     reloadMargins(true);
                                 };

                                 $scope.shareWhatIf = function (whatIf) {
                                     whatIf.shared = !whatIf.shared;

                                     $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + whatIf.id + "/share", whatIf.shared)
                                          .then(function (response) {
                                          });

                                 };

                                 $scope.cloneWhatIf = function (whatIf) {
                                     var trades = whatIf.tradeDetails.map(function (t) {
                                         return {
                                             code: t.code,
                                             quantity: t.quantity
                                         };
                                     });

                                     var equityTrades = whatIf.equityTradeDetails.map(function (t) {
                                         return {
                                             code: t.underlyingCode,
                                             quantity: t.quantity
                                         }
                                     });

                                     const allTrades = trades.concat(equityTrades);

                                     $scope.svcCreateWhatIf(whatIf.name + " (copy)", allTrades).then(function (whatIf) {
                                         $timeout(function () {
                                             $scope.$broadcast("whatif.flushed");
                                             $scope.setActiveWhatIf(whatIf);
                                         }, 0);
                                     });
                                 };

                                 $scope.clearWhatIf = function (whatIf) {

                                     confirmationService.confirm(confirmationTypes.clearStrategy).then(function () {
                                         whatIf.trades = [];

                                         // ok to just destroy any unsaved updates
                                         clearPendingWhatIfUpdates();
                                         $scope.svcUpdateWhatIfTrades($scope.activeWhatIf, []).then(function () {
                                             $scope.$broadcast("whatif.flushed");
                                             reloadMarginsNow();
                                             $scope.$broadcast("whatif.changed", whatIf);
                                         });
                                     });
                                 };

                                 $scope.deleteWhatIf = function (whatIf) {
                                     $scope.whatIfs = $scope.whatIfs.filter(function (w) {
                                         return w !== whatIf;
                                     });

                                     return $scope.svcDeleteWhatIf(whatIf).then(function () {
                                         $scope.$broadcast("whatif.flushed");
                                         createDefaultWhatIf();
                                     });
                                 };

                                 $scope.deleteAllWhatIfs = function () {

                                     confirmationService.confirm(confirmationTypes.deleteAllStrategies).then(function () {
                                         $q.all($scope.whatIfs.filter(function (w) {
                                             return w.mine && !w.pinned;
                                         })
                                                      .map($scope.svcDeleteWhatIf))
                                           .then(function () {
                                               $scope.$broadcast("whatif.flushed");
                                               createDefaultWhatIf();
                                           });

                                         $scope.whatIfs = $scope.whatIfs.filter(function (w) {
                                             return !w.mine || w.pinned;
                                         });
                                     });
                                 };

                                 function createDefaultWhatIf() {
                                     var myWhatIfs = $scope.whatIfs.filter(function (w) {
                                         return w.mine;
                                     });

                                     if (!myWhatIfs.length) {
                                         $scope.createWhatIf([]);
                                     }
                                 }

                                 function broadcastWhatIfChange(whatIf) {
                                     $scope.$broadcast("whatif.changed", whatIf);
                                 }

                                 function uniqueBy(array, matchFn) {
                                     return array.filter((item, index, self) => {
                                         const key = matchFn(item);
                                         const firstIndex = self.findIndex((entry) => {
                                             const entryKey = matchFn(entry);
                                             return entryKey === key;
                                         });
                                         return firstIndex === index;
                                     })
                                 }

                                 $scope.svcUpdateWhatIfTrades = function (whatIf, whatIfTrades) {
                                     return $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + whatIf.id + "/trades", whatIfTrades).then(function (response) {
                                         whatIf.trades = response.data;
                                         return whatIf.trades;
                                     });
                                 };

                                 $scope.svcCreateWhatIf = function (whatIfName, whatIfTrades, tmc) {
                                     var newWhatIf = {
                                         name: whatIfName,
                                         trades: whatIfTrades,
                                         shared: false,
                                         mine: true,
                                         tmc
                                     };

                                     return $http.put("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs", newWhatIf)
                                                 .then(function (response) {
                                                     var data = response.data;
                                                     $scope.whatIfs.push(data);
                                                     return data;
                                                 });
                                 };

                                 $scope.svcDeleteWhatIf = function (whatIf) {
                                     return $http.delete("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + whatIf.id)
                                                 .then(function (response) {
                                                     if ($localStorage["widgetParams" + whatIf.id]) {
                                                         delete $localStorage["widgetParams" + whatIf.id];
                                                     }
                                                 });
                                 };

                                 $scope.suffixWhatIfName = function (name) {
                                     var myWhatIfs = $scope.whatIfs.filter(function (w) {
                                         return w.mine;
                                     });

                                     var nameMatch = new RegExp("^" + name + " (\\d+)$");
                                     var matchingSuffixes = [0];

                                     myWhatIfs.forEach(function (w) {
                                         var match = w.name.replace(nameMatch, "$1");
                                         if (match === w.name) {
                                             return;
                                         }

                                         var suffix = +match;
                                         if (suffix) {
                                             matchingSuffixes.push(suffix);
                                         }
                                     });

                                     matchingSuffixes.sort(function (a, b) {
                                         if (a > b) {
                                             return -1;
                                         }

                                         if (a < b) {
                                             return 1;
                                         }

                                         return 0;
                                     });

                                     return name + " " + (matchingSuffixes[0] + 1); // always have one value
                                 };

                                 $scope.createWhatIf = function (trades, tmc) {
                                     var whatIfName = $scope.unlimitedWhatIfs ? $scope.suffixWhatIfName("Strategy") : "Strategy";
                                     var whatIfTrades = trades || [];

                                     return $scope.svcCreateWhatIf(whatIfName, whatIfTrades, tmc).then(function (w) {
                                         $timeout(function () {
                                             $scope.$broadcast("whatif.flushed");
                                             $scope.setActiveWhatIf(w);
                                         }, 0);
                                     });
                                 };

                                 $scope.deleteWhatIfTrade = function (position) {
                                     const whatIf = $scope.activeWhatIf;
                                     whatIf.trades = $scope.activeWhatIf.trades.filter((value) => value.id !== position.id);
                                     return $scope.svcUpdateWhatIfTrades(whatIf, whatIf.trades).then(() => reloadMargins(true));
                                 };

                                 function updateTrade(whatIf, position) {
                                     const existing = whatIf.trades.find(function (tr) {
                                         return tr.id === position.id
                                     });
                                     const updated = Object.assign(existing, {code: position.code});
                                     var allTrades = [updated].concat(whatIf.trades);
                                     var trades = uniqueBy(allTrades, (trade) => trade.id);
                                     return $scope.svcUpdateWhatIfTrades(whatIf, trades);
                                 }

                                 function positionUpdated(position) {
                                     if ($scope.activeWhatIf != null) {
                                         queueWhatIfUpdate();
                                         return updateTrade($scope.activeWhatIf, position).then(reloadMarginsNow);
                                     } else {
                                         return strategyService.updateStrategy($scope.activeStrategy)
                                                               .then(reloadMarginsNow)
                                                               .then(function () {
                                                                   var changeSummary = ticketService.calculateChangeSummary($scope.allMarginSummary);
                                                                   $scope.activeStrategy.marginDetails = changeSummary
                                                               })
                                     }
                                 }

                                 function trades() {
                                     if ($scope.activeStrategy != null) {
                                         return $scope.activeStrategy.trades;
                                     } else {
                                         return $scope.activeWhatIf.trades;
                                     }
                                 }

                                 $scope.nextStrike = function (position) {
                                     optionService.nextStrike(position, trades())
                                                  .then(function (updated) {
                                                      Object.assign(position, updated);
                                                      return positionUpdated(updated)
                                                  });
                                 };

                                 $scope.previousStrike = function (position) {
                                     optionService.previousStrike(position, trades())
                                                  .then(function (updated) {
                                                      Object.assign(position, updated);
                                                      return positionUpdated(updated)
                                                  });
                                 };

                                 $scope.nextExpiry = function (position) {
                                     optionService.nextExpiry(position, trades())
                                                  .then(function (updated) {
                                                      Object.assign(position, updated);
                                                      return positionUpdated(updated)
                                                  });
                                 };

                                 $scope.previousExpiry = function (position) {
                                     optionService.previousExpiry(position, trades())
                                                  .then(function (updated) {
                                                      Object.assign(position, updated);
                                                      return positionUpdated(updated)
                                                  });
                                 };

                                 $scope.rollWhatIfTrade = function (position) {
                                     chainService(position.security).then(function (chain) {
                                         var nextSeries = chain.codes[position.code].series.nextSeries;
                                         if (nextSeries) {
                                             var rung = nextSeries.rungAtOrAfter(position.strike);

                                             var newInstrument = (position.type == "PUT" ? rung.put : rung.call);

                                             if (newInstrument != null) {

                                                 var whatIf = $scope.activeWhatIf;
                                                 var exists = whatIf.trades.some(function (trade) {
                                                     return trade.code.toUpperCase() == newInstrument.code.toUpperCase();
                                                 });

                                                 if (!exists) {

                                                     var trade = {
                                                         code: newInstrument.code,
                                                         quantity: -position.quantity
                                                     };

                                                     if (whatIf.tmc) {
                                                         $scope.createWhatIf([trade]);
                                                     } else {
                                                         var trades = whatIf.trades.concat(trade);

                                                         flushPendingWhatIfUpdates().then(function () {
                                                             $scope.svcUpdateWhatIfTrades(whatIf, trades).then(reloadMarginsNow).then(function () {
                                                                 $scope.$broadcast("whatif.flushed");
                                                                 broadcastWhatIfChange(whatIf);
                                                             });
                                                         });
                                                     }
                                                 }
                                             }

                                         }
                                     });
                                 };

                                 $scope.removeManualNewBusiness = function (position) {
                                     $scope.newBusiness.removeNewBusiness(position).then(function () {
                                         loadPortfolio(false);
                                     });
                                 };

                                 $scope.includeNewBusinessTrade = function (position) {
                                     position.include = !position.include;

                                     currentPositions.forEach(function (p) {
                                         if (p.id == position.id) {
                                             p.i = !p.i;
                                         }
                                     });

                                     reloadMargins(true);
                                 };

                                 $scope.openStockScreener = function () {
                                     var vm = this;
                                     var modalInstance = $uibModal.open({
                                         templateUrl: "app/apps/stockScreener/stockScreener.tpl.html",
                                         controller: "stockScreenerCtrl as stockScreenerCtrl",
                                         size: "fs",
                                         windowClass: "fsModalScreener",
                                         resolve: {
                                             actionText: function () {
                                                 return "View in portfolio"
                                             }
                                         }
                                     });
                                     modalInstance.result.then(function (underlying) {
                                         vm.createPositionForm.code.$setViewValue(underlying);
                                     });
                                 };

                                 $scope.openCollateralTicket = function (equityCollateral) {
                                     var modalInstance = $uibModal.open({
                                         templateUrl: "app/portfolio/templates/ticket/ticketCollateral.tpl.html",
                                         controller: "ticketCollateralCtrl as ticketCollateralCtrl",
                                         size: "lg",

                                         resolve: {
                                             trades: function () {
                                                 var trades = [];
                                                 if (equityCollateral) {
                                                     var trade = {
                                                         issuer: equityCollateral.issuer,
                                                         quantity: -equityCollateral.quantity,
                                                         id: equityCollateral.id
                                                     };
                                                     trades.push(trade);
                                                 } else {
                                                     trades = $scope.equityTrades;
                                                 }
                                                 return trades;
                                             },
                                             collateral: function () {
                                                 return $scope.equityCollateral;
                                             }
                                         }
                                     });

                                     modalInstance.result.then(function () {
                                         $scope.equityCollateralFormData.isValid = true;
                                         $scope.equityCollateralFormData.issuer = null;
                                         $scope.equityCollateralFormData.totalCost = null;
                                         $scope.equityCollateralFormData.price = null;
                                         $scope.equityCollateralFormData.value = null;
                                         $scope.equityCollateralFormData.quantity = 0;
                                         $scope.equityTrades = [];
                                         loadPortfolio(false);
                                     });
                                 };

                                 $scope.addCollateral = function () {
                                     if (userConfig.backOffice === "GAME") {
                                         $scope.openCollateralTicket();
                                     } else {
                                         var newEquityCollateral = {
                                             issuer: $scope.equityCollateralFormData.issuer.code,
                                             quantity: $scope.equityCollateralFormData.quantity,
                                             price: 0,
                                             specificCover: false,
                                             available: 0
                                         };
                                         $http.put("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/equity", newEquityCollateral)
                                              .then(function (response) {
                                                  var data = response.data;
                                                  $scope.equityCollateralFormData.isValid = true;
                                                  $scope.equityCollateralFormData.issuer = null;
                                                  $scope.equityCollateralFormData.totalCost = null;
                                                  $scope.equityCollateralFormData.price = null;
                                                  $scope.equityCollateralFormData.value = null;
                                                  $scope.equityCollateralFormData.quantity = 0;
                                                  $scope.equityTrades = [];
                                                  loadPortfolio(false);
                                              })
                                              .catch(function () {
                                                  $scope.equityCollateralFormData.isValid = false;
                                              });
                                     }

                                 };

                                 $scope.addCash = function () {
                                     var newCashCollateral = {
                                         issuer: $scope.cashCollateralFormData.issuer,
                                         value: $scope.cashCollateralFormData.value
                                     };
                                     $http.put("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/cash", newCashCollateral).then(function (response) {
                                         $scope.cashCollateralFormData.value = "";
                                         $scope.cashCollateralFormData.issuer = "";
                                         loadPortfolio(false);
                                     });
                                 };

                                 $scope.updateCollateral = function (equityCollateral) {
                                     var newEquityCollateral = {
                                         id: equityCollateral.id,
                                         quantity: equityCollateral.quantity,
                                         specificCover: equityCollateral.specificCover
                                     }

                                     $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/equity", newEquityCollateral).then(function (response) {
                                         loadPortfolio(true);
                                     });
                                 };

                                 $scope.updateCoverType = function (equityCollateral) {
                                     equityCollateral.specificCover = !equityCollateral.specificCover;
                                     $scope.updateCollateral(equityCollateral);
                                 };

                                 $scope.updateCash = function (cashCollateral) {
                                     $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/cash", cashCollateral).then(function (response) {
                                         loadPortfolio(false);
                                     });
                                     reloadMargins(false);
                                 };

                                 $scope.resetAccount = function () {
                                     var resetConfirmTemplate = "<div class=\"modal-header\">\n" +
                                         "<h3 class=\"modal-title\"><i class=\"icon-help_outline\"></i> Reset your account</h3>\n" +
                                         "</div>\n" +
                                         "<div class=\"modal-body\">\n" +
                                         "    <p>\n" +
                                         " Are you sure you want to remove all of your positions?\n" +
                                         "    </p>\n" +
                                         "</div>\n" +
                                         "<div class=\"modal-footer\">\n" +
                                         "    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$close(true)\">Yes</button>\n" +
                                         "    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$dismiss(false)\">No</button>\n" +
                                         "</div>\n";

                                     $uibModal.open({template: resetConfirmTemplate}).result.then(function () {
                                         $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/reset").then(function (response) {
                                             loadPortfolio(false);
                                         });
                                     });
                                 };

                                 $scope.deleteCollateral = function (equityCollateral) {
                                     if (userConfig.backOffice == "GAME") {
                                         $scope.openCollateralTicket(equityCollateral);
                                     } else {
                                         $http.delete("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/equity/" + equityCollateral.id);
                                         for (var i = 0; i < $scope.portfolioEquityCollateral.length; i++) {
                                             if ($scope.portfolioEquityCollateral[i].id == equityCollateral.id) {
                                                 $scope.portfolioEquityCollateral.splice(i, 1);
                                             }
                                         }
                                         loadPortfolio(false);
                                     }
                                 };

                                 $scope.deleteCash = function (cashCollateral) {
                                     $http.delete("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/cash/" + cashCollateral.id);
                                     for (var i = 0; i < $scope.portfolioCashCollateral.length; i++) {
                                         if ($scope.portfolioCashCollateral[i].id == cashCollateral.id) {
                                             $scope.portfolioCashCollateral.splice(i, 1);
                                         }
                                     }
                                     reloadMargins(true);
                                 };

                                 $scope.inviteClient = function () {

                                     var modalInstance = $uibModal.open({

                                         templateUrl: "app/portfolio/templates/inviteClient/inviteClient.tpl.html",
                                         windowClass: "margin-top50 inviteClient",
                                         controller: "inviteClientCtrl as inviteClientCtrl",
                                         resolve: {
                                             linkedUsers: function () {
                                                 return $scope.portfolio.linkedUsers;
                                             }
                                         },
                                         size: "md"
                                     }).result.then(function (inviteInfo) {
                                         $http
                                             .post("/tradefloor/api/user/invite", {
                                                 email: inviteInfo.email,
                                                 name: inviteInfo.name
                                             })
                                             .then(function (response) {
                                                 var userData = response.data;
                                                 $http
                                                     .put("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/link/" + userData.id, {})
                                                     .then(function (response) {
                                                         growl.success("Invitation sent to " + inviteInfo.name, {});
                                                     })
                                                     .catch(
                                                         function (e) {
                                                             growl.error('Failed to link user, please contact support')
                                                         }
                                                     )
                                             })
                                             .catch(
                                                 function (e) {
                                                     growl.error('Failed to send invite, please contact support')
                                                 }
                                             )
                                         ;
                                     });
                                 };


                                 $scope.openNewBusiness = function (whatIf) {

                                     var modalInstance = $uibModal.open({
                                         templateUrl: "app/portfolio/templates/newBusiness/newBusiness.html",
                                         controller: "NewBusinessCtrl",
                                         size: "lg",

                                         resolve: {
                                             newBusiness: function () {
                                                 return $scope.newBusiness;
                                             },
                                             trades: function () {
                                                 var newBusinessTrades = [];

                                                 for (var i = 0; i < whatIf.equityTradeDetails.length; i++) {
                                                     var equityTrade = whatIf.equityTradeDetails[i];

                                                     newBusinessTrades.push({
                                                         code: equityTrade.underlyingCode,
                                                         quantity : equityTrade.quantity,
                                                         price: equityTrade.price,
                                                         id: equityTrade.id,
                                                         manual: true,
                                                         tradeDate: $scope.today,
                                                         include: true,
                                                         contract: {
                                                             code: equityTrade.underlyingCode,
                                                             underlying: equityTrade.underlyingCode,
                                                             type: 'STOCK',
                                                             style: null,
                                                             strike: null,
                                                             expiry: null
                                                         }
                                                     });
                                                 }

                                                 for (var i = 0; i < whatIf.tradeDetails.length; i++) {
                                                     var trade = whatIf.tradeDetails[i];
                                                     newBusinessTrades.push({
                                                         code: trade.code,
                                                         quantity : trade.quantity,
                                                         price: trade.theoPrice,
                                                         id: trade.id,
                                                         manual: true,
                                                         tradeDate: $scope.today,
                                                         include: true,
                                                         contract: {
                                                             code: trade.code,
                                                             underlying: trade.security,
                                                             type: trade.type,
                                                             style: trade.style,
                                                             strike: trade.strike,
                                                             expiry: trade.expiry
                                                         }
                                                     });
                                                 }
                                                 return newBusinessTrades;
                                             }

                                         }
                                     });

                                     modalInstance.result.then(function (trades) {
                                         if (!trades.length) {
                                             return;
                                         }

                                         if ($scope.activeWhatIf) {
                                             removeTradesFromWhatIf($scope.activeWhatIf, trades);
                                         }

                                         loadPortfolio(false);
                                     });
                                 };

                                 $scope.openMobOptionPicker = function () {
                                     var modalInstance = $uibModal.open({
                                         templateUrl: "app/portfolio/templates/mobileWhatIf/mobileWhatIf.tpl.html",
                                         controller: "openMobOptionPickerCtrl as openMobOptionPickerCtrl",
                                         size: "fs"
                                     });

                                     modalInstance.result.then(function (selectedItem) {
                                         $scope.selected = selectedItem;
                                     }, function () {
                                     });
                                 };

                                 $scope.openCollateral = async () => {
                                     await collateralLodgingService.open($scope.portfolioId);
                                     reloadMarginsNow();
                                 };

                                 $scope.openTicket = async function (whatIf) {
                                     let order = whatIf;
                                     if (!whatIf.tmc) {
                                         try {
                                             order = await strategyService.strategyToTmc(whatIf, true);
                                         } catch (e) {
                                             // TMC Creation failed, just place as singles
                                         }
                                     }

                                     const results = placeOrderService.openOrderWindow(order, $scope.portfolioId, $scope.portfolio.portfolioType, $scope.portfolio.accountName, $scope.today);

                                     results.then(function (allocatedOrders) {
                                         if (allocatedOrders.length) {
                                             if ($scope.activeWhatIf != null) {
                                                 // TODO Ivan wanted this not deleted for now
                                                 // $scope.deleteWhatIf(whatIf);
                                             } else {
                                                 // $scope.deleteStrategy(whatIf)
                                             }
                                             /// XXX Trigger a manual refresh of the order
                                         }
                                     });
                                 };

                                 function removeTradesFromWhatIf(whatIf, trades) {
                                     var updatedTrades = whatIf.trades.map(function (t) {
                                         return {
                                             id: t.id,
                                             code: t.code,
                                             quantity: t.quantity
                                         }
                                     });

                                     for (var i = 0; i < trades.length; i++) {
                                         var newBusinessTrade = trades[i];

                                         for (var j = whatIf.trades.length - 1; j >= 0; j--) {
                                             var whatIfTrade = updatedTrades[j];

                                             if (whatIfTrade.code === newBusinessTrade.code && whatIfTrade.quantity != 0) {

                                                 var offset = whatIfTrade.quantity >= 0 ?
                                                     Math.min(whatIfTrade.quantity, newBusinessTrade.quantity) :
                                                     Math.max(whatIfTrade.quantity, newBusinessTrade.quantity);


                                                 whatIfTrade.quantity -= offset;

                                                 break;
                                             }
                                         }
                                     }

                                     updatedTrades = updatedTrades.filter(function (t) {
                                         return t.quantity != 0;
                                     });

                                     // Remove the empty what if
                                     if (updatedTrades.length == 0 && $scope.unlimitedWhatIfs) {
                                         $scope.deleteWhatIf(whatIf).then(loadPortfolioAndWhatIf);
                                     } else {
                                         $scope.svcUpdateWhatIfTrades(whatIf, updatedTrades).then(function () {
                                             loadPortfolioAndWhatIf();
                                             broadcastWhatIfChange(whatIf);
                                         });
                                     }
                                 }

                                 $scope.focusOptnChain = function () {
                                     var whatifPosCreate = angular.element(document.getElementById("whatifPosCreate"));
                                     $document.scrollToElement(whatifPosCreate, 50, 1000);
                                 };

                                 $scope.renameWhatIf = function (name) {
                                     $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs/" + $scope.activeWhatIf.id + "/name", name).then(function (response) {
                                     });

                                 };


                                 $scope.whatIfQuantityChanged = function (position) {
                                     for (var i = 0; i < $scope.activeWhatIf.trades.length; i++) {
                                         var trade = $scope.activeWhatIf.trades[i];

                                         if (trade.id == position.id) {
                                             var equity = $scope.equityCollateral.find(function (equity) {
                                                 return equity.issuer === position.code
                                             });
                                             // They cannot trade Equities more than what they have.
                                             if (equity && equity.quantity * -1 > position.quantity) {
                                                 position.quantity = equity.quantity * -1;
                                             }
                                             trade.quantity = position.quantity;
                                             break;
                                         }
                                     }
                                     queueWhatIfUpdate();
                                     reloadMargins();
                                 };

                                 $scope.toggleClosedPos = function () {
                                     $localStorage.showClosedPositions = !$localStorage.showClosedPositions;
                                     $scope.updateGrid();
                                 };

                                 function createClosePositionStrategy(code, trades, title) {
                                     $scope.quickWhatIfService.update(trades);
                                 }

                                 $scope.closePositions = function () {

                                     var selection = $scope.gridApi.selection.getSelectedGridRows();

                                     if (!selection.length) {
                                         selection = $scope.gridApi.core.getVisibleRows();
                                     }

                                     var positions = selection.map(function (row) {
                                         return row.entity;
                                     });

                                     var code = null;

                                     var newTrades = positions.filter(function (position) {
                                         return position.whatIfQuantity != 0;
                                     }).map(function (p) {
                                         code = p.code.substring(0, 3);
                                         return {
                                             code: p.code,
                                             quantity: -p.quantity
                                         };
                                     });

                                     $scope.gridApi.selection.clearSelectedRows();

                                     if (newTrades.length) {
                                         if (userConfig.strategyBasedView) {
                                             createClosePositionStrategy(code, newTrades, "Close " + code);
                                         } else {
                                             $scope.createWhatIf(newTrades);
                                         }
                                     }
                                 };

                                 $scope.closeRollPositions = function () {
                                     var selection = $scope.gridApi.selection.getSelectedGridRows();

                                     if (!selection.length) {
                                         selection = $scope.gridApi.core.getVisibleRows();
                                     }

                                     var positions = selection.map(function (row) {
                                         return row.entity;
                                     });

                                     var code = null;

                                     var newTrades = positions.filter(function (position) {
                                         return position.whatIfQuantity !== 0;
                                     }).map(function (p) {
                                         code = p.code.substring(0, 3);
                                         return {
                                             code: p.code,
                                             quantity: -p.whatIfQuantity
                                         };
                                     });

                                     var rolls = positions.filter(function (position) {
                                         return position.whatIfQuantity !== 0;
                                     }).map(function (p) {

                                         return chainService(p.security).then(function (chain) {
                                             var nextSeries = chain.codes[p.code].series.nextSeries;
                                             if (nextSeries) {
                                                 var rung = nextSeries.rungAtOrAfter(p.strike);

                                                 var newInstrument = (p.type == "PUT" ? rung.put : rung.call);

                                                 if (newInstrument != null) {
                                                     var trade = {
                                                         code: newInstrument.code,
                                                         quantity: p.whatIfQuantity
                                                     };
                                                     newTrades.push(trade);
                                                 }
                                             }
                                         });
                                     });

                                     $q.all(rolls).then(function () {
                                         if (newTrades.length) {
                                             if (userConfig.strategyBasedView) {
                                                 createClosePositionStrategy(code, newTrades, "Close and Roll " + code);
                                             } else {
                                                 $scope.createWhatIf(newTrades);
                                             }
                                         }
                                     });

                                     $scope.gridApi.selection.clearSelectedRows();
                                 };

                                 $scope.selectDefaultWhatIf = function () {
                                     var myWhatIfs = $scope.whatIfs.filter(function (w) {
                                         return w.mine;
                                     });

                                     if (myWhatIfs.length) {
                                         $scope.setActiveWhatIf(myWhatIfs[0]);
                                     }
                                 };

                                 $scope.closePosition = function (position) {
                                     var currentWhatIf = $scope.activeWhatIf;

                                     if (!$scope.unlimitedWhatIfs && !$scope.activeWhatIf) {
                                         $scope.selectDefaultWhatIf();
                                     }

                                     if (currentWhatIf == null || currentWhatIf.tmc) {
                                         $scope.createWhatIf(
                                             [{
                                                 code: position.code,
                                                 quantity: -position.quantity
                                             }]
                                         );
                                     } else {
                                         flushPendingWhatIfUpdates().then(function () {
                                             var updatedTrades = angular.copy(currentWhatIf.trades);

                                             var wasAdded = false;
                                             for (var i = 0; i < updatedTrades.length; i++) {
                                                 var trade = updatedTrades[i];
                                                 if (trade.code == position.code) {
                                                     trade.quantity -= position.quantity;
                                                     wasAdded = true;
                                                     break;
                                                 }
                                             }

                                             if (!wasAdded) {
                                                 var newWhatIfTrade = {
                                                     code: position.code,
                                                     quantity: -position.quantity
                                                 };
                                                 updatedTrades.unshift(newWhatIfTrade);
                                             }

                                             $scope.svcUpdateWhatIfTrades(currentWhatIf, updatedTrades).then(reloadMarginsNow).then(function () {
                                                 $scope.$broadcast("whatif.flushed");
                                                 broadcastWhatIfChange(currentWhatIf);
                                             });
                                         });
                                     }
                                 };

                                 $scope.clearPositionSecurity = function () {
                                     $scope.createPosition.instrument = null;
                                 };

                                 function clearCreateWhatIfTrade(form) {
                                     $scope.createPosition.instrument = null;
                                     $scope.createPosition.quantity = null;
                                     if (form) {
                                         form.$setPristine();
                                         form.$setUntouched();
                                     }
                                 }

                                 $scope.instrumentSelected = function () {
                                     // TODO this is only working because the model is updated after the single click, but before the double click
                                     var form = this.createPositionForm;
                                     $scope.createWhatIfTrade(form);
                                 };


                                 $scope.underlyingSelected = function (underlying) {

                                     var currentWhatIf = $scope.activeWhatIf;
                                     // If there is the same code trade, ignore it.
                                     var exists = currentWhatIf.trades.some(function (trade) {
                                         return trade.code === underlying;
                                     });
                                     if (exists) {
                                         return;
                                     }
                                     var updatedTrades = angular.copy(currentWhatIf.trades);

                                     var newWhatIfTrade = {
                                         code: underlying,
                                         quantity: 0
                                     };
                                     updatedTrades.unshift(newWhatIfTrade);

                                     $scope.svcUpdateWhatIfTrades(currentWhatIf, updatedTrades)
                                           .then(reloadMarginsNow)
                                           .then(function () {
                                               broadcastWhatIfChange(currentWhatIf);
                                           });
                                 };

                                 $scope.createWhatIfTrade = function (form) {
                                     if (!form.$valid) {
                                         return;
                                     }
                                     var currentWhatIf = $scope.activeWhatIf;
                                     var updatedTrades = angular.copy(currentWhatIf.trades);

                                     var wasAdded = false;
                                     for (var i = 0; i < updatedTrades.length; i++) {
                                         var trade = updatedTrades[i];
                                         if (trade.code.toUpperCase() == $scope.createPosition.instrument.code.toUpperCase()) {
                                             trade.quantity += +$scope.createPosition.quantity;
                                             wasAdded = true;
                                             break;
                                         }
                                     }

                                     if (!wasAdded) {
                                         var newWhatIfTrade = {
                                             code: $scope.createPosition.instrument.code,
                                             quantity: +$scope.createPosition.quantity
                                         };
                                         updatedTrades.unshift(newWhatIfTrade);
                                     }

                                     $scope.autoFocusCode = true;

                                     $timeout(function () {
                                         $scope.autoFocusCode = false;
                                     }, 0);

                                     $scope.svcUpdateWhatIfTrades(currentWhatIf, updatedTrades).then(reloadMarginsNow).then(function () {
                                         broadcastWhatIfChange(currentWhatIf);
                                     });

                                     clearCreateWhatIfTrade(form);

                                 };

                                 function reloadMargins(now) {
                                     if (reloadMarginsTimeout) {
                                         $timeout.cancel(reloadMarginsTimeout);
                                         reloadMarginsTimeout = null;
                                     }

                                     if (now) {
                                         reloadMarginsNow();
                                     } else {
                                         reloadMarginsTimeout = $timeout(reloadMarginsNow, 1000);
                                     }
                                 }

                                 function reloadMarginsDeferred() {
                                     reloadMargins(false);
                                 }

                                 // removes fields that the server doesn't understand
                                 function generateScenario() {
                                     if ($scope.activeScenario != null) {
                                         return {
                                             modelType: $scope.activeScenario.modelType || null,
                                             marketScenario: $scope.activeScenario.marketScenario,
                                             sectorScenarios: $scope.activeScenario.sectorScenarios,
                                             securityScenarios: $scope.activeScenario.securityScenarios,
                                             asAt: $scope.activeScenario.asAt
                                         };
                                     } else {
                                         return null;
                                     }
                                 }

                                 function generateStrategyData(currentStrategy) {

                                     if (currentStrategy == null) {
                                         return {
                                             scenarioDefinitions: generateScenario(),
                                             strategies: []
                                         }
                                     }

                                     const legs = currentStrategy.trades
                                                                 .map((t) => ObjectUtil.pick(t, "id", "code", "quantity"));
                                     const strategy = {
                                         legs,
                                         pinned: false,
                                         tmc: currentStrategy.tmc,
                                         scaleFactor: currentStrategy.scaleFactor
                                     };

                                     return {
                                         scenarioDefinitions: generateScenario(),
                                         strategies: [strategy]
                                     }
                                 }

                                 function calculateChangeSummary(baseMargin, whatIfMargin, marginSummary) {
                                     var newChangeSummary = {
                                         costOfTrade: whatIfMargin.costOfTrades,
                                         premiumChange: whatIfMargin.premiumMargin - baseMargin.premiumMargin,
                                         brokerage: -(whatIfMargin.brokerage + whatIfMargin.brokerageTax),
                                         brokerageTax: whatIfMargin.brokerageTax,
                                         fees: -(whatIfMargin.fees + whatIfMargin.feesTax),
                                         feesTax: whatIfMargin.feesTax,
                                         changeInMargin: whatIfMargin.totalMargin - baseMargin.totalMargin,
                                         changeInScan: whatIfMargin.scanRisk - baseMargin.scanRisk,
                                         addMargin: (whatIfMargin.clientMargin - whatIfMargin.totalMargin) - (baseMargin.clientMargin - baseMargin.totalMargin),
                                         changeInIC: whatIfMargin.interCommodityConcession - baseMargin.interCommodityConcession,
                                         netEffect: 0,
                                         currentShortage: baseMargin.shortageExcess - baseMargin.lepoMtm,
                                         whatIfShortage: whatIfMargin.shortageExcess,
                                         nlv: marginSummary.nlv,
                                         lepoMtm: whatIfMargin.lepoMtm,
                                         utilisation: whatIfMargin.utilisation,
                                         utilisationPct: whatIfMargin.utilisation * 100,
                                         utilisationClamped: Math.min(100, whatIfMargin.utilisation * 100),
                                         utilisationLevel: barColour(whatIfMargin.utilisation)
                                     };

                                     newChangeSummary.totalMargin = newChangeSummary.changeInMargin + newChangeSummary.addMargin;
                                     newChangeSummary.changeInCollateral = whatIfMargin.collateralBalance - baseMargin.collateralBalance;
                                     newChangeSummary.netEffect = newChangeSummary.costOfTrade - whatIfMargin.brokerage - whatIfMargin.brokerageTax - whatIfMargin.fees - whatIfMargin.feesTax - (newChangeSummary.changeInMargin + newChangeSummary.addMargin) + newChangeSummary.changeInCollateral;
                                     newChangeSummary.shortageAdjustment = (whatIfMargin.shortageExcess - whatIfMargin.lepoMtm) - (newChangeSummary.netEffect + newChangeSummary.currentShortage);
                                     newChangeSummary.whatIfShortage = whatIfMargin.shortageExcess;

                                     if (Math.abs(newChangeSummary.shortageAdjustment) < 0.01) {
                                         newChangeSummary.shortageAdjustment = 0;
                                     }

                                     if (Math.abs(newChangeSummary.lepoMtm) < 0.01) {
                                         newChangeSummary.lepoMtm = 0;
                                     }

                                     if (Math.abs(newChangeSummary.addMargin) < 0.01) {
                                         newChangeSummary.addMargin = 0;
                                     }

                                     return newChangeSummary;
                                 }

                                 function reloadMarginsNow() {
                                     // The tab directive is quite aggressive with calling the selection callback
                                     // Check if the portfolio data has been loaded before we attempt to margin it
                                     if (!$scope.portfolio) {
                                         return $q.reject();
                                     }

                                     reloadMarginsTimeout = null;

                                     // TODO check if the stress test will have any effect and don't send it if it won't
                                     // check price/vol == 0 and no time shift

                                     function calculateMargin(marginData, activeWhatIf) {

                                         return portfolioService.margin($stateParams.portfolioId, marginData).then(function (marginSummary) {

                                             var currentMargin = marginSummary.currentMarginSummary;
                                             var scenarioMargin = marginSummary.scenarioSummary;
                                             var whatIfMargin = marginSummary.whatIfSummary;
                                             var whatIfTrades = marginSummary.trades;

                                             $scope.whatIfTrades = marginSummary.trades;
                                             $scope.whatIfEquityTrades = marginSummary.equityTradeDetails;

                                             $scope.allMarginSummary = marginSummary;
                                             $scope.currentMargin = currentMargin;
                                             $scope.whatIfMargin = whatIfMargin;
                                             $scope.scenarioMargin = scenarioMargin;

                                             $scope.eodMarginChange = {
                                                 etoLedger: $scope.currentMargin.etoLedger - $scope.eodMargin.etoLedger,
                                                 equityLedger: $scope.currentMargin.equityLedger - $scope.eodMargin.equityLedger,
                                                 cmBalance: $scope.currentMargin.cmBalance - $scope.eodMargin.cmBalance,
                                                 equityValue: $scope.currentMargin.equityValue - $scope.eodMargin.equityValue,
                                                 premiumMargin: $scope.currentMargin.premiumMargin - $scope.eodMargin.premiumMargin,
                                                 spanMargin: $scope.currentMargin.spanMargin - $scope.eodMargin.spanMargin,
                                                 clientMargin: $scope.currentMargin.clientMargin - $scope.eodMargin.clientMargin,
                                                 nlv: $scope.currentMargin.nlv - $scope.eodMargin.nlv,
                                                 shortageExcess: $scope.currentMargin.shortageExcess - $scope.eodMargin.shortageExcess
                                             };

                                             $scope.eodMarginWhatIfChange = {
                                                 etoLedger: $scope.whatIfMargin.etoLedger - $scope.eodMargin.etoLedger,
                                                 equityLedger: $scope.whatIfMargin.equityLedger - $scope.eodMargin.equityLedger,
                                                 cmBalance: $scope.whatIfMargin.cmBalance - $scope.eodMargin.cmBalance,
                                                 equityValue: $scope.whatIfMargin.equityValue - $scope.eodMargin.equityValue,
                                                 premiumMargin: $scope.whatIfMargin.premiumMargin - $scope.eodMargin.premiumMargin,
                                                 spanMargin: $scope.whatIfMargin.spanMargin - $scope.eodMargin.spanMargin,
                                                 clientMargin: $scope.whatIfMargin.clientMargin - $scope.eodMargin.clientMargin,
                                                 nlv: $scope.whatIfMargin.nlv - $scope.eodMargin.nlv,
                                                 shortageExcess: $scope.whatIfMargin.shortageExcess - $scope.eodMargin.shortageExcess
                                             };

                                             $scope.currentMarginWhatIfChange = {
                                                 etoLedger: $scope.whatIfMargin.etoLedger - $scope.currentMargin.etoLedger,
                                                 equityLedger: $scope.whatIfMargin.equityLedger - $scope.currentMargin.equityLedger,
                                                 cmBalance: $scope.whatIfMargin.cmBalance - $scope.currentMargin.cmBalance,
                                                 equityValue: $scope.whatIfMargin.equityValue - $scope.currentMargin.equityValue,
                                                 premiumMargin: $scope.whatIfMargin.premiumMargin - $scope.currentMargin.premiumMargin,
                                                 spanMargin: $scope.whatIfMargin.spanMargin - $scope.currentMargin.spanMargin,
                                                 clientMargin: $scope.whatIfMargin.clientMargin - $scope.currentMargin.clientMargin,
                                                 nlv: $scope.whatIfMargin.nlv - $scope.currentMargin.nlv,
                                                 shortageExcess: $scope.whatIfMargin.shortageExcess - $scope.currentMargin.shortageExcess
                                             };

                                             $scope.singleUnderlying = whatIfMargin.combinedCommodities.length <= 1;

                                             $scope.totalPnl = whatIfMargin.unrealisedProfitLoss;
                                             $scope.realisedPnl.forEach(function (expiry) {
                                                 $scope.totalPnl += expiry.profit;
                                             });

                                             $scope.currentPointInTime = marginSummary.currentPointInTime;
                                             $scope.eodPointInTime = marginSummary.eodPointInTime;

                                             $scope.latestAsx.name = "Latest ASX " + $scope.dateFilter(marginSummary.currentPointInTime, "shortTime");
                                             $scope.latestUpdatedAsx.name = "Latest Updated Params " + $scope.dateFilter(marginSummary.currentPointInTime, "shortTime");
                                             $scope.xjoPrice = currentMargin.price;
                                             $scope.prices = {};
                                             currentMargin.combinedCommodities.forEach(function (cc) {
                                                 $scope.prices[cc.security] = cc.price;
                                             });

                                             marginSummary.equityTradeDetails.forEach(function (etd) {
                                                 if ($scope.equityCollateralFormData.issuer && etd.underlyingCode == $scope.equityCollateralFormData.issuer.code && etd.quantity == $scope.equityCollateralFormData.quantity) {
                                                     $scope.equityCollateralFormData.totalCost = etd.price * etd.quantity;
                                                     $scope.equityCollateralFormData.price = etd.price;
                                                     $scope.equityCollateralFormData.value = etd.price * etd.quantity * (1.0 - etd.haircut);
                                                 }
                                             });

                                             whatIfMargin.combinedCommodities.filter(function (cc) {
                                                 return cc.security != "XJO" && cc.security != "SPI";
                                             })
                                                         .forEach(function (cc) {
                                                             var exists = $scope.stockParams.stocks.some(function (stock) {
                                                                 return stock.security == cc.security;
                                                             });

                                                             if (!exists) {
                                                                 $scope.stockParams.stocks.push({
                                                                     collapsed: true,
                                                                     security: cc.security,
                                                                     enabled: false,
                                                                     originalPrice: cc.price,
                                                                     price: $scope.simpleStressTesting ? cc.price : 0,
                                                                     priceType: $scope.simpleStressTesting ? "@" : "%",
                                                                     vol: 0,
                                                                     activePricePreset: null,
                                                                     activeVolPreset: null,
                                                                     customPrice: $scope.simpleStressTesting ? cc.price : null,
                                                                     customVol: null,
                                                                     customPriceType: $scope.simpleStressTesting ? "@" : "%",
                                                                     pricePresets: createDefaultPricePresets(),
                                                                     volPresets: createDefaultVolPresets()
                                                                 });
                                                             }
                                                         });
                                             var removed = 0;
                                             for (var i = 0; (i - removed) < $scope.stockParams.stocks.length; i++) {
                                                 var toRemove = true;
                                                 for (var j = 0; j < whatIfMargin.combinedCommodities.length; j++) {
                                                     if (whatIfMargin.combinedCommodities[j].security == $scope.stockParams.stocks[i - removed].security) {
                                                         toRemove = false;
                                                     }
                                                 }
                                                 if (toRemove) {
                                                     $scope.stockParams.stocks.splice(i - removed, 1);
                                                     removed = removed + 1;
                                                 }
                                             }
                                             if ($scope.marketParams == null) {
                                                 $scope.marketParams = {
                                                     collapsed: true,
                                                     security: "Market",
                                                     enabled: false,
                                                     price: $scope.simpleStressTesting ? $scope.xjoPrice : 0,
                                                     priceType: $scope.simpleStressTesting ? "@" : "%",
                                                     vol: 0,
                                                     activePricePreset: null,
                                                     activeVolPreset: null,
                                                     customPrice: $scope.simpleStressTesting ? $scope.xjoPrice : null,
                                                     customVol: null,
                                                     customPriceType: $scope.simpleStressTesting ? "@" : "%",
                                                     pricePresets: createDefaultPricePresets(),
                                                     volPresets: createDefaultVolPresets()
                                                 };
                                             }

                                             $scope.stockParams.stocks.sort(function (a, b) {
                                                 if (a.security < b.security) {
                                                     return -1;
                                                 }

                                                 if (a.security > b.security) {
                                                     return 1;
                                                 }

                                                 return 0;
                                             });

                                             $scope.totalEquityCollateral = 0;
                                             $scope.totalCashCollateral = 0;
                                             $scope.totalUnlodgedCollateral = 0;

                                             $scope.unlodgedCollateral = (scenarioMargin ? scenarioMargin.unlodgedCollateral : currentMargin.unlodgedCollateral);
                                             $scope.unlodgedCollateral.forEach(function (value) {
                                                 $scope.totalUnlodgedCollateral += value.value;
                                             });

                                             $scope.equityCollateral = (scenarioMargin ? scenarioMargin.equityCollateral : currentMargin.equityCollateral);

                                             $scope.equityCollateral.sort(function (a, b) {
                                                 if (a.issuer < b.issuer) {
                                                     return -1;
                                                 }

                                                 if (a.issuer > b.issuer) {
                                                     return 1;
                                                 }

                                                 return 0;
                                             });

                                             $scope.cashCollateral = currentMargin.cashCollateral.sort(function (a, b) {
                                                 if (a.issuer < b.issuer) {
                                                     return -1;
                                                 }

                                                 if (a.issuer > b.issuer) {
                                                     return 1;
                                                 }

                                                 return 0;
                                             });

                                             $scope.equityCollateral.forEach(function (value) {
                                                 $scope.totalEquityCollateral += value.value;
                                                 if (value.profit == null) {
                                                     value.profit = 0;
                                                 }
                                             });

                                             $scope.cashCollateral.forEach(function (value) {
                                                 $scope.totalCashCollateral += value.value;
                                             });

                                             $scope.systemNewBusinessPositions = marginSummary.newBusinessTrades.filter(function (value) {
                                                 return !value.manual;
                                             });
                                             $scope.manualNewBusinessPositions = marginSummary.newBusinessTrades.filter(function (value) {
                                                 return value.manual;
                                             });

                                             $scope.yesterdayTrades = marginSummary.yesterdayTrades;

                                             var newBusinessTotals = {};

                                             marginSummary.newBusinessTrades.forEach(function (value) {
                                                 var total = newBusinessTotals[value.code];
                                                 if (!total) {
                                                     total = {
                                                         quantity: 0,
                                                         premium: 0
                                                     };

                                                     newBusinessTotals[value.code] = total;
                                                 }

                                                 total.quantity += value.quantity;
                                                 total.premium += value.premium;

                                             });

                                             var totalNewBusiness = 0;
                                             marginSummary.newBusinessTrades.forEach(function (value) {
                                                 if (value.include) {
                                                     totalNewBusiness += value.premium;
                                                 }
                                             });
                                             $scope.totalNewBusiness = totalNewBusiness;

                                             var totalYesterdayBusiness = 0;
                                             marginSummary.yesterdayTrades.forEach(function (value) {
                                                 if (value.include) {
                                                     totalYesterdayBusiness += value.premium;
                                                 }
                                             });
                                             $scope.totalYesterdayBusiness = totalYesterdayBusiness;


                                             $scope.priceDate = new Date(marginSummary.pointInTime);
                                             $scope.oldPrice = new Date().getTime() - $scope.priceDate.getTime() > 3600000 * 4;

                                             var baseMargin = scenarioMargin != null ? scenarioMargin : currentMargin;
                                             $scope.baseMargin = baseMargin;
                                             var basePositions = baseMargin.positions;

                                             // add the generated row from Equity

                                             const equityPositions = baseMargin.equityPositions;
                                             equityPositions.forEach(pos => {
                                                 const positionData = makePositionData({
                                                     quantity: pos.quantity,
                                                     security: pos.code,
                                                     code: pos.code,
                                                     type: "STOCK",
                                                     delta: 1,
                                                     dollarDelta: 1 * pos.quantity * pos.price, // delta * quantity * underlyingPrice
                                                     netDelta: 1 * pos.quantity, // delta * quantity
                                                     netDeltaPercent: pos.price * pos.quantity / 100.0, // underlyingPrice * 1% * qty
                                                     openPrice: pos.totalCost / pos.quantity,
                                                     theoPrice: pos.price,
                                                     premiumMargin: pos.quantity * pos.price,
                                                     cvf: 1,
                                                     underlyingPrice: pos.price,
                                                     unrealPnL: pos.profit,
                                                     todayPnL: pos.todayPnl,
                                                     additionalMargin: 0
                                                 });
                                                 basePositions.push(positionData);
                                             });

                                             for (var i = 0; i < basePositions.length; i++) {
                                                 var position = basePositions[i];

                                                 position.dollarDelta = position.underlyingPrice * position.netDelta;
                                                 var baseSide = 0;
                                                 var itm = false;

                                                 if (position.type === "PUT") {
                                                     baseSide = -1;
                                                     itm = position.strike > position.underlyingPrice;
                                                     position.intrinsicValue = Math.max(0, (position.strike - position.underlyingPrice));
                                                 } else if (position.type === "CALL") {
                                                     baseSide = 1;
                                                     itm = position.strike < position.underlyingPrice;
                                                     position.intrinsicValue = Math.max(0, (position.underlyingPrice - position.strike));
                                                 } else {
                                                     itm = false;
                                                 }

                                                 position.itm = itm;

                                                 var side = baseSide * position.quantity;

                                                 if (side < 0) {
                                                     itm = position.strike < position.underlyingPrice;
                                                 } else if (side > 0) {
                                                     itm = position.strike > position.underlyingPrice;
                                                 } else {
                                                     itm = false;
                                                 }
                                                 position.badPosition = itm;

                                             }

                                             $scope.gridData = basePositions;

                                             // TODO workaround until we have better filtering
                                             $scope.gridData.forEach(function (value) {
                                                 value.typeFilter = value.type + "-" + value.style;
                                                 value.newBusiness = newBusinessTotals[value.code];
                                                 if (value.type == "STOCK") {
                                                     value.securityDescription = (value.quantity < 0 ? "SOLD" : "BO'T") + " " +
                                                         +Math.abs(value.quantity) + " shares of "
                                                         + value.code; // TODO add the description
                                                 } else {
                                                     value.securityDescription = (value.quantity < 0 ? "SOLD" : "BO'T") + " " +
                                                         +Math.abs(value.quantity) + " "
                                                         + value.security + " "
                                                         + $filter("strike")(value.strike, value.security === "XJO") + " "
                                                         + $filter("date")(value.expiry, "MMM dd ''yy") + " "
                                                         + $filter("type")(value.type) + " "
                                                         + "(" + $filter("style")(value.style) + ")";
                                                 }

                                             });

                                             $scope.gridData.sort(function (a, b) {
                                                 if (a.security < b.security)
                                                     return -1;
                                                 if (a.security > b.security)
                                                     return 1;

                                                 if (a.expiry < b.expiry)
                                                     return -1;
                                                 if (a.expiry > b.expiry)
                                                     return 1;

                                                 if (a.strike < b.strike)
                                                     return -1;
                                                 if (a.strike > b.strike)
                                                     return 1;
                                                 return 0;
                                             });
                                             $scope.gridOptions.data = $scope.gridData;


                                             $scope.gridOptions.data = $scope.gridOptions.data.filter(function (p) {
                                                 return p.quantity != 0 || $localStorage.showClosedPositions;
                                             });

                                             // TODO this was copied from updateGrid, but it seems really wrong to do it this way
                                             // We should have a full set of grid data then run a filter over it to get the final
                                             $scope.gridOptions.data = $scope.gridOptions.data.filter(function (p) {
                                                 if (!$scope.includeEquities && p.type === "STOCK") {
                                                     return false;
                                                 }

                                                 return true;
                                             });

                                             $scope.gridOptions.data = $scope.gridOptions.data.filter(function (p) {
                                                 if (!$scope.includeOptions && p.type !== "STOCK") {
                                                     return false;
                                                 }

                                                 return true;
                                             });
                                             $timeout(function () {
                                                 if ($scope.gridApi) {
                                                     $scope.gridApi.treeBase.expandAllRows();
                                                 }
                                             });
                                             $timeout($scope.updateTableHeight);

                                             // shallow copy.  quantity can be amended for TMC.
                                             marginData.positions = ArrayUtil.clone(whatIfTrades);

                                             for (var ietd = 0; ietd < marginSummary.equityTradeDetails.length; ietd++) {
                                                 var equity = marginSummary.equityTradeDetails[ietd];

                                                 const isInTrades = marginData.positions.some((position) => position.code === equity.underlyingCode);
                                                 // if this Equity does not exist on Position. (It probably won't)
                                                 if (!isInTrades) {
                                                     marginData.positions.push(makePositionData({
                                                         id: equity.id, // ?? No id??
                                                         quantity: equity.quantity,
                                                         security: equity.underlyingCode,
                                                         code: equity.underlyingCode,
                                                         type: "STOCK",
                                                         delta: 1, // always one for stock
                                                         dollarDelta: 1 * equity.quantity * equity.price, // delta * quantity * underlyingPrice
                                                         netDelta: 1 * equity.quantity, // delta * quantity
                                                         netDeltaPercent: equity.price * equity.quantity / 100.0, // underlyingPrice * 1% * qty
                                                         theoPrice: equity.price,
                                                         cvf: 1,
                                                         underlyingPrice: equity.price,
                                                         additionalMargin: 0,
                                                         premium: equity.premium,
                                                         theoSpreadSummary: {
                                                             code: equity.underlyingCode,
                                                             bid: equity.bid,
                                                             ask: equity.ask,
                                                             mid: (equity.ask + equity.bid) / 2.0,
                                                             theo: undefined, // ?? same as mid?
                                                             askVol: undefined,
                                                             bidVol: undefined,
                                                         },
                                                     }));
                                                 }
                                             }


                                             if (activeWhatIf != null) {
                                                 marginData.positions.forEach((pos) => {
                                                     const trade = activeWhatIf.trades.find((tr) => tr.id === pos.id);
                                                     if (trade != null) {
                                                         pos.quantity = trade.quantity
                                                     }
                                                 });
                                             }

                                             marginData.positions.forEach(function (position) {
                                                 position.newBusiness = newBusinessTotals[position.code];
                                             });

                                             // Calculate summary
                                             var newChangeSummary = calculateChangeSummary(baseMargin, whatIfMargin, marginSummary);
                                             $scope.changeSummary = newChangeSummary;

                                             var newWhatIfTotals = {
                                                 netDelta: 0,
                                                 dollarDelta: 0,
                                                 premium: marginSummary.totalPremium,
                                                 marginEffect: 0,
                                                 theo: 0
                                             };

                                             whatIfTrades.forEach(function (w) {
                                                 newWhatIfTotals.netDelta += w.netDelta;
                                                 newWhatIfTotals.dollarDelta += w.dollarDelta;
                                                 newWhatIfTotals.marginEffect += w.marginEffect;
                                                 newWhatIfTotals.theo += w.theoPrice * (marginData.tmc ? w.quantity / marginData.lots : w.quantity);
                                             });

                                             marginSummary.equityTradeDetails.forEach((t) => {
                                                 newWhatIfTotals.netDelta += t.netDelta;
                                                 const theo = (t.quantity / marginSummary.gcd) * t.price;
                                                 newWhatIfTotals.theo += theo;
                                             });

                                             if (newWhatIfTotals.marginEffect < 0) {
                                                 newWhatIfTotals.marginEffect = 0;
                                             }

                                             $scope.gcd = marginSummary.gcd;
                                             $scope.strategyCost = marginSummary.strategyCost;

                                             $scope.whatIfTotals = newWhatIfTotals;

                                             var baseChangeMargin = eodMargin;
                                             if (scenarioMargin != null) {
                                                 baseChangeMargin = currentMargin;
                                             }

                                             var newMarginSummary = {
                                                 scenarioActive: scenarioMargin != null,
                                                 whatIfShortage: newChangeSummary.whatIfShortage,
                                                 whatIfMargin: whatIfMargin.clientMargin,
                                                 totalMarginCurrent: whatIfMargin.clientMargin,
                                                 shortageChange: whatIfMargin.shortageExcess - baseChangeMargin.shortageExcess,
                                                 shortageChangeCurrent: whatIfMargin.shortageExcess - baseChangeMargin.shortageExcess,
                                                 shortageCurrent: whatIfMargin.shortageExcess,
                                                 reportedShortage: $scope.reportedShortage,
                                                 reportedShortageChange: $scope.reportedShortage - baseChangeMargin.shortageExcess,
                                                 marginChange: whatIfMargin.clientMargin - baseChangeMargin.clientMargin,
                                                 marginChangeCurrent: whatIfMargin.clientMargin - baseChangeMargin.clientMargin,
                                                 addMargin: whatIfMargin.clientMargin - whatIfMargin.totalMargin,
                                                 addMarginChange: (whatIfMargin.clientMargin - whatIfMargin.totalMargin) - (baseChangeMargin.clientMargin - baseChangeMargin.totalMargin),
                                                 eodMargin: baseChangeMargin.clientMargin,
                                                 utilisation: whatIfMargin.utilisation,
                                                 utilisationPct: whatIfMargin.utilisation * 100,
                                                 collateralBalance: whatIfMargin.collateralBalance,
                                                 collateralChange: whatIfMargin.collateralBalance - baseChangeMargin.collateralBalance,
                                                 collateralRemaining: Math.max(whatIfMargin.collateralBalance - whatIfMargin.collateralUsed, 0),
                                                 cashBalance: whatIfMargin.cashBalance,
                                                 cashChange: whatIfMargin.cashBalance - baseChangeMargin.cashBalance,
                                                 cmBalance: whatIfMargin.cmBalance,
                                                 cmChange: whatIfMargin.cmBalance - baseChangeMargin.cmBalance,
                                                 totalCash: whatIfMargin.cashBalance + (whatIfMargin.cmBalance || 0) + whatIfMargin.collateralBalance,
                                                 totalCashChange: (whatIfMargin.cashBalance + (whatIfMargin.cmBalance || 0) + whatIfMargin.collateralBalance)
                                                     - (baseChangeMargin.cashBalance + (baseChangeMargin.cmBalance || 0) + baseChangeMargin.collateralBalance),
                                                 marginMultiplier: whatIfMargin.marginMultiplier,
                                                 todayPnl: scenarioMargin == null ? (whatIfMargin.unrealisedProfitLoss - eodMargin.unrealisedProfitLoss) : (whatIfMargin.unrealisedProfitLoss - baseChangeMargin.unrealisedProfitLoss),
                                                 unrealisedPnl: whatIfMargin.unrealisedProfitLoss,
                                                 spanMargin: whatIfMargin.spanMargin,
                                                 spanMarginCurrent: whatIfMargin.spanMargin,
                                                 spanMarginChange: whatIfMargin.spanMargin - baseChangeMargin.spanMargin,
                                                 premiumMargin: whatIfMargin.premiumMargin,
                                                 premiumMarginCurrent: whatIfMargin.premiumMargin,
                                                 premiumMarginChange: whatIfMargin.premiumMargin - baseChangeMargin.premiumMargin,
                                                 etoLedger: whatIfMargin.etoLedger,
                                                 etoLedgerChange: whatIfMargin.etoLedger - baseChangeMargin.etoLedger,
                                                 equityLedger: whatIfMargin.equityLedger,
                                                 equityLedgerChange: whatIfMargin.equityLedger - baseChangeMargin.equityLedger
                                             };

                                             if (newMarginSummary.shortageCurrent < 0) {
                                                 newMarginSummary.shortageChangeCurrentUp = newMarginSummary.shortageChangeCurrent < 0;
                                             } else {
                                                 newMarginSummary.shortageChangeCurrentUp = newMarginSummary.shortageChangeCurrent > 0;
                                             }

                                             if (newMarginSummary.unrealisedPnl < 0) {
                                                 newMarginSummary.todayPnlUp = newMarginSummary.todayPnl < 0;
                                             } else {
                                                 newMarginSummary.todayPnlUp = newMarginSummary.todayPnl > 0;
                                             }

                                             $scope.marginSummary = newMarginSummary;

                                             $scope.cmaFormData = $scope.marginSummary.cmBalance;


                                             $scope.updateCma = function (cmBalance) {
                                                 $http.post("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/collateral/cma", cmBalance)
                                                      .then(function (response) {
                                                          loadPortfolio(false);
                                                      })
                                             };

                                             for (var i = 0; i < basePositions.length; i++) {
                                                 var realPosition = basePositions[i];

                                                 for (var j = 0; j < whatIfMargin.positions.length; j++) {
                                                     var whatIfPosition = whatIfMargin.positions[j];

                                                     if (whatIfPosition.code == realPosition.code) {
                                                         realPosition.whatIfQuantity = whatIfPosition.quantity;
                                                         realPosition.whatIfEffect = whatIfPosition.netEffect;
                                                         realPosition.whatIfMarginEffect = whatIfPosition.marginEffect;
                                                         break;
                                                     }
                                                 }

                                                 for (var j = 0; j < whatIfMargin.equityPositions.length; j++) {
                                                     var whatIfPosition = whatIfMargin.equityPositions[j];

                                                     if (whatIfPosition.code == realPosition.code) {
                                                         realPosition.whatIfQuantity = whatIfPosition.quantity;
                                                         realPosition.whatIfEffect = whatIfPosition.netEffect;
                                                         realPosition.whatIfMarginEffect = whatIfPosition.marginEffect;
                                                         break;
                                                     }
                                                 }
                                             }

                                             function getSecurityCode(accumulator, summary) {
                                                 accumulator[summary.security] = true;
                                                 return accumulator;
                                             }

                                             var allSecurities = {};
                                             eodMargin.combinedCommodities.reduce(getSecurityCode, allSecurities);
                                             currentMargin.combinedCommodities.reduce(getSecurityCode, allSecurities);
                                             whatIfMargin.combinedCommodities.reduce(getSecurityCode, allSecurities);

                                             if (scenarioMargin) {
                                                 scenarioMargin.combinedCommodities.reduce(getSecurityCode, allSecurities);
                                             }

                                             function createFakeSummary(security) {
                                                 return {
                                                     security: security,
                                                     premiumMargin: 0,
                                                     spanMargin: 0,
                                                     scanRisk: 0,
                                                     psr: {
                                                         scanAmount: 0
                                                     },
                                                     vsr: {
                                                         scanAmount: 0
                                                     },
                                                     spanDelta: 0,
                                                     netDelta: 0,
                                                     dollarDelta: 0,
                                                     spanDeltaUsed: 0,
                                                     weightedDeltaAvailable: 0,
                                                     weightedDeltaUsed: 0,
                                                     icConcession: 0,
                                                     totalMargin: 0,
                                                     clientMargin: 0,
                                                     wfpr: 0,
                                                     riskArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                                                 }
                                             }

                                             var eodSecurities = {};
                                             eodMargin.combinedCommodities.reduce(getSecurityCode, eodSecurities);
                                             Object.keys(allSecurities).forEach(function (entry) {
                                                 if (!eodSecurities[entry]) {
                                                     eodMargin.combinedCommodities.push(createFakeSummary(entry));
                                                 }
                                             });

                                             var currentSecurities = {};
                                             currentMargin.combinedCommodities.reduce(getSecurityCode, currentSecurities);
                                             Object.keys(allSecurities).forEach(function (entry) {
                                                 if (!currentSecurities[entry]) {
                                                     currentMargin.combinedCommodities.push(createFakeSummary(entry));
                                                 }
                                             });

                                             var whatIfSecurities = {};
                                             whatIfMargin.combinedCommodities.reduce(getSecurityCode, whatIfSecurities);
                                             Object.keys(allSecurities).forEach(function (entry) {
                                                 if (!whatIfSecurities[entry]) {
                                                     whatIfMargin.combinedCommodities.push(createFakeSummary(entry));
                                                 }
                                             });

                                             if (scenarioMargin) {
                                                 var scenarioSecurities = {};
                                                 scenarioMargin.combinedCommodities.reduce(getSecurityCode, scenarioSecurities);
                                                 Object.keys(allSecurities).forEach(function (entry) {
                                                     if (!scenarioSecurities[entry]) {
                                                         scenarioMargin.combinedCommodities.push(createFakeSummary(entry));
                                                     }
                                                 });
                                             }

                                             $scope.lastUpdated = new Date();
                                             $scope.$broadcast("margin.whatif.changed", whatIfMargin, scenarioMargin, currentMargin, eodMargin, marginData);
                                             $scope.lastMarginWhatifChangedData = {
                                                 marginData: marginData,
                                                 whatIfMargin: whatIfMargin,
                                                 scenarioMargin: scenarioMargin,
                                                 currentMargin: currentMargin,
                                                 eodMargin: eodMargin
                                             };
                                         });
                                     }

                                     // TODO add a method to calculate (POST)

                                     function whatIfToScenarioStrategy(whatIf, pinned) {
                                         const scaleFactor = whatIf.lots || 1;
                                         const legs = whatIf.trades.map((t) => ObjectUtil.pick(t, "id", "code", "quantity"));
                                         return {
                                             legs,
                                             scaleFactor,
                                             tmc: whatIf.tmc,
                                             pinned
                                         }
                                     }

                                     function generateWhatIfData(currentWhatIf) {

                                         const scenarioDefinitions = generateScenario();

                                         if (currentWhatIf == null) {
                                             return {
                                                 scenarioDefinitions,
                                                 strategies: []
                                             }
                                         }

                                         const pinnedWhatIfs = $scope.whatIfs
                                                                     .filter((whatIf) => whatIf !== currentWhatIf)
                                                                     .filter((whatIf) => whatIf.pinned)
                                                                     .filter((whatIf) => whatIf.trades.length > 0)
                                                                     .map((w) => whatIfToScenarioStrategy(w, true));

                                         if (currentWhatIf.trades.length === 0) {
                                             return {
                                                 scenarioDefinitions,
                                                 strategies: pinnedWhatIfs
                                             }
                                         }

                                         const current = whatIfToScenarioStrategy(currentWhatIf, false);

                                         return {
                                             scenarioDefinitions,
                                             strategies: [current].concat(pinnedWhatIfs)
                                         };
                                     }

                                     if ($scope.activeStrategy != null) {
                                         var strategyMarginData = generateStrategyData($scope.activeStrategy);
                                         return calculateMargin(strategyMarginData, $scope.activeStrategy).then(function () {
                                             var scaleFactor = $scope.activeStrategy.scaleFactor || 0;
                                             $scope.activeStrategy.tradeDetails = $scope.whatIfTrades;
                                             $scope.activeStrategy.equityTradeDetails = $scope.whatIfEquityTrades;
                                             $scope.activeStrategy.positions = $scope.whatIfTrades;
                                             $scope.activeStrategy.tradeDetails.forEach(function (t) {
                                                 t.quantity = t.quantity / scaleFactor;
                                             });
                                             $scope.activeStrategy.equityTradeDetails.forEach(function (t) {
                                                 t.quantity = t.quantity / scaleFactor;
                                             });
                                         })
                                     } else if ($scope.activeWhatIf != null) {
                                         var marginData = generateWhatIfData($scope.activeWhatIf);
                                         return calculateMargin(marginData, $scope.activeWhatIf).then(function () {
                                             $scope.activeWhatIf.tradeDetails = $scope.whatIfTrades;
                                             $scope.activeWhatIf.equityTradeDetails = $scope.whatIfEquityTrades;
                                             $scope.activeWhatIf.positions = $scope.lastMarginWhatifChangedData.marginData.positions;
                                         })
                                     } else {
                                         var emptyData = generateWhatIfData();
                                         return calculateMargin(emptyData)
                                     }
                                 }

                                 $scope.setActiveStrategy = function (strategy) {
                                     if ($scope.gridApi != null) {
                                         $scope.gridApi.selection.clearSelectedRows();
                                     }

                                     if (strategy == null) {
                                         $scope.activeStrategy = null;

                                         $scope.payoff.includeRealPositions = true;
                                     } else {
                                         $scope.activeStrategy = strategy;
                                         // $scope.activeStrategy
                                         //       .trades
                                         //       .forEach(tr => tr.quantity = tr.quantity * $scope.activeStrategy.scaleFactor);
                                         $scope.payoff.includeRealPositions = false;
                                     }

                                     selectBestCashBalanceChange();

                                     // We have a little bit of a race condition on page load where the strategies may be loaded
                                     // before the portfolio and then the active one selected.
                                     // The end of the Load Portfolio code will also call reloadMargins anyway
                                     if ($scope.portfolio != null) {
                                         reloadMargins(true);
                                     }
                                 };

                                 function loadPortfolioAndWhatIf() {
                                     loadPortfolio(true);
                                 }

                                 function loadPortfolio(loadWhatIfs) {

                                     flushPendingWhatIfUpdates().then(function () {
                                         Positions.get(function onPortfolioLoaded(p) {
                                             $scope.updatedParamsAvailable = p.updatedParamsAvailable;
                                             var today = new Date(moment(p.today).format());
                                             $scope.today = p.today;

                                             // TODO We would only want to do this on first load, not any reloads (although the time may change)
                                             $scope.timeDecayScenario.selectedDate = today;
                                             $scope.timeDecayScenario.asAt = $scope.dateFilter($scope.timeDecayScenario.selectedDate, "yyyy-MM-dd");

                                             var etoExpiry = new Date(p.nextEtoExpiry);
                                             var indexExpiry = new Date(p.nextIndexExpiry);

                                             etoExpiry.setHours(0);
                                             etoExpiry.setMinutes(0);
                                             etoExpiry.setSeconds(0);
                                             etoExpiry.setMilliseconds(0);

                                             indexExpiry.setHours(0);
                                             indexExpiry.setMinutes(0);
                                             indexExpiry.setSeconds(0);
                                             indexExpiry.setMilliseconds(0);

                                             $scope.indexExpiry = indexExpiry;
                                             $scope.etoExpiry = etoExpiry;

                                             var oneDay = 24 * 60 * 60 * 1000;
                                             var daysUntilEtoExpiry = Math.round((etoExpiry.getTime() - today.getTime()) / oneDay);
                                             var daysUntilIndexExpiry = Math.round((indexExpiry.getTime() - today.getTime()) / oneDay);

                                             $scope.nextEtoExpiryScenario.asAt = $scope.dateFilter(etoExpiry, "yyyy-MM-dd");
                                             $scope.nextEtoExpiryScenario.name = "ETO Expiry " + $scope.dateFilter(etoExpiry, "MMM dd") + " (" + daysUntilEtoExpiry + (daysUntilEtoExpiry == 1 ? " day" : " days") + ")";

                                             $scope.nextIndexExpiryScenario.asAt = $scope.dateFilter(indexExpiry, "yyyy-MM-dd");
                                             $scope.nextIndexExpiryScenario.name = "Index Expiry " + $scope.dateFilter(indexExpiry, "MMM dd") + " (" + daysUntilIndexExpiry + (daysUntilIndexExpiry == 1 ? " day" : " days") + ")";


                                             $scope.portfolioEquityCollateral = p.eodMarginSummary.equityCollateral;
                                             $scope.portfolioCashCollateral = p.eodMarginSummary.cashCollateral;

                                             $scope.newBusiness = newBusiness(p.id);
                                             $scope.reportedShortage = p.reportedShortage;

                                             $scope.realisedPnl = p.realisedProfit;
                                             $scope.totalPnl = 0;

                                             $scope.portfolio = p;
                                             $state.current.data.pageTitle = "Portfolio " + p.accountName;

                                             p.favourite = navSvc.isFavourite(p);
                                             navSvc.openPortfolio(p);

                                             marginMultiplier = p.marginMultiplier;
                                             marginSchedule = p.marginSchedule;
                                             etoBrokerageSchedule = p.etoBrokerageSchedule;
                                             lepoBrokerageSchedule = p.lepoBrokerageSchedule;
                                             equityBrokerageSchedule = p.equityBrokerageSchedule;
                                             limitMultiplier = p.limitMultiplier;
                                             scratch = p.scratch;
                                             etoLedger = p.etoLedger;
                                             equityLedger = p.equityLedger;
                                             cmBalance = p.cmBalance;
                                             eodMargin = p.eodMarginSummary;
                                             $scope.eodMargin = eodMargin;
                                             currentPositions = p.positions;
                                             equityPositions = p.equityPositions;


                                             $scope.historicalExcessDates = p.historicalSummary.map(function (summary) {
                                                 return summary.pointInTime;
                                             });
                                             $scope.historicalExcessData = p.historicalSummary.map(function (summary) {
                                                 return summary.shortageExcess;
                                             });
                                             $scope.historicalMarginDates = p.historicalSummary.map(function (summary) {
                                                 return summary.pointInTime;
                                             });

                                             $scope.historicalMarginData = p.historicalSummary.map(function (summary) {
                                                 return summary.clientMargin;
                                             });
                                             $scope.portfolioUpdated = p.updated;


                                             if (loadWhatIfs) {

                                                 // Ensure portfolio loaded before we load what ifs
                                                 function retrieveWhatIfs() {
                                                     $http.get("/tradefloor/api/portfolio/" + $stateParams.portfolioId + "/whatifs")
                                                          .then(function onWhatIfsLoaded(whatifs) {
                                                              $scope.whatIfsLoaded = true;
                                                              $scope.whatIfs = whatifs.data;

                                                              if ($scope.whatIfs.length === 0) {
                                                                  $scope.createWhatIf();
                                                              } else {

                                                                  if ($scope.whatIfTabs.activeIndex.indexOf("WhatIf") === 0) {

                                                                      var myWhatIfs = $scope.whatIfs.filter(function (w) {
                                                                          return w.mine;
                                                                      });

                                                                      var firstWhatIf = myWhatIfs.shift();

                                                                      // TODO we shouldn't have to remove the WhatIf bit here
                                                                      var activeWhatIf = +$scope.whatIfTabs.activeIndex.replace("WhatIf", "");

                                                                      if (!activeWhatIf) {
                                                                          if (firstWhatIf) {
                                                                              activeWhatIf = firstWhatIf.id;
                                                                          }
                                                                      }

                                                                      var foundActiveWhatIf = false;
                                                                      $scope.whatIfs.forEach(function (w) {
                                                                          if (w.id == activeWhatIf) {
                                                                              $scope.setActiveWhatIf(w);
                                                                              foundActiveWhatIf = true;
                                                                          }
                                                                      });

                                                                      if (!foundActiveWhatIf) {
                                                                          if (firstWhatIf) {
                                                                              // Revert back to first what if (if there is one)
                                                                              $scope.setActiveWhatIf(firstWhatIf);
                                                                          } else {
                                                                              // Or open the default view
                                                                              // TODO select the default for this back office/skin
                                                                              $scope.selectCurrent("TradeActivity");
                                                                          }
                                                                      }
                                                                  } else {
                                                                      switch ($localStorage[portfolioPrefsKey].selectedTab) {
                                                                          case "Collateral":
                                                                              reloadMargins(true);
                                                                              break;
                                                                          case "TradeActivity":
                                                                              reloadMargins(true);
                                                                              break;
                                                                          case "TradeHistory" :
                                                                              loadTradeHistory();
                                                                              break;
                                                                          default:
                                                                              // TODO select the default for this back office/skin
                                                                              $scope.selectCurrent("TradeActivity");
                                                                              break;
                                                                      }
                                                                  }
                                                              }
                                                          })
                                                 }

                                                 if (!userConfig.strategyBasedView) {
                                                     $timeout(retrieveWhatIfs)
                                                 } else {
                                                     reloadMargins(true);
                                                 }

                                             } else {
                                                 reloadMargins(true);
                                             }
                                         });
                                     });
                                 }

                                 loadPortfolioAndWhatIf();

                                 $scope.gridData = [];

                                 $scope.updateFilterTerm = function (col) {
                                     if (col.dateTerm) {
                                         col.term = $filter("date")(col.dateTerm, "yyyy-MM");
                                     } else {
                                         col.term = "";
                                     }
                                 };

                                 function setupColumns() {
                                     // TODO change this to an object
                                     // addColumn(column) -- set visible to hidden by default if enableHiding != false
                                     // Adds a field with the name of the column
                                     // setColumnVisible(column) -- set visible to true
                                     // getColumnDefs -- return the full list of columns in added order

                                     var columns = {
                                         close: {
                                             name: "close",
                                             type: "boolean",
                                             displayName: "",
                                             width: "27",
                                             headerCellClass: "gridNoOverflow",
                                             enableFiltering: false,
                                             enableSorting: false,
                                             enableHiding: false, cellTooltip: true,
                                             enableColumnMenu: false,
                                             enableColumnResizing: false,
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\"><a ng-click=\"grid.appScope.closePosition(row.entity)\" class=\"text-close\"><i class=\"fa-fw icon-close\"></i></a></div>"
                                         },

                                         quantity: {
                                             name: "quantity",
                                             field: "quantity",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.qty,
                                             enableFiltering: false,
                                             enableColumnResizing: true,
                                             visible: false,
                                             cellTooltip: true,
                                             cellFilter: "number:0",
                                             displayName: "Quantity",
                                             width: "100",
                                             cellClass: "gridQty",
                                             cellTemplate: "<div ng-if=\"row.groupHeader\" class=\"ui-grid-cell-contents\">\n    {{COL_FIELD CUSTOM_FILTERS}}\n</div>\n<div ng-if=\"!row.groupHeader\" class=\"ui-grid-cell-contents\"\n     ng-class=\"{qtyChanged : row.entity.quantity != row.entity.whatIfQuantity}\">\n    <span ng-class=\"{sell : row.entity.quantity < 0}\">{{row.entity.quantity | numberFixed:5:false}}</span>\n    <span ng-if=\"row.entity.quantity != row.entity.whatIfQuantity\" ng-class=\"{sell : row.entity.whatIfQuantity < 0}\">\n        {{row.entity.whatIfQuantity | numberFixed:7:true}}\n    </span>\n</div>"
                                         },
                                         code: {
                                             name: "code",
                                             type: "string",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.code, cellTooltip: true,
                                             displayName: "Code",
                                             width: "**",
                                             visible: false
                                         },
                                         security: {
                                             name: "security",
                                             type: "string",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.security,
                                             displayName: "Security",
                                             width: "**", cellTooltip: true,
                                             visible: false
                                         },

                                         securityDescription: {
                                             name: "securityDescription",
                                             type: "string",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             displayName: "Description",
                                             width: "***", cellTooltip: true,
                                             visible: false,
                                             cellTemplate: "<div class=\"ui-grid-cell-contents position-description-cell\">\n    <span ng-if=\"row.entity.quantity != row.entity.whatIfQuantity\"\n          ng-class=\"{sell : row.entity.whatIfQuantity < 0}\"\n          uib-tooltip=\"Quantity after the trade is executed.\">\n        <strong>({{row.entity.whatIfQuantity}})</strong>\n    </span>\n    <span ng-if=\"!row.groupHeader\" ng-class=\"{buy : row.entity.whatIfQuantity > 0, sell: row.entity.whatIfQuantity < 0}\">\n        {{COL_FIELD CUSTOM_FILTERS}}\n    </span>\n    <div ng-if=\"row.groupHeader\">\n        <span ng-class=\"{buy : row.entity.whatIfQuantity > 0, sell: row.entity.whatIfQuantity < 0}\">\n            {{COL_FIELD.display CUSTOM_FILTERS}}\n        </span>\n    </div>\n</div>",
                                             customTreeAggregationFn: function (aggregation, fieldValue, numValue, row) {

                                                 if (typeof (aggregation.count) === "undefined") {
                                                     aggregation.count = 0;
                                                     aggregation.security = row.entity.security;
                                                     aggregation.underlyingPrice = row.entity.underlyingPrice;
                                                 }
                                                 aggregation.count++;

                                                 aggregation.value = aggregation.security;
                                             },
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 var display = aggregation.security + " (" + aggregation.count + ") " + $filter("price")(aggregation.underlyingPrice, aggregation.security == "XJO");
                                                 var columnVal = {
                                                     security: aggregation.security,
                                                     count: aggregation.count
                                                 };
                                                 columnVal.display = display;
                                                 aggregation.rendered = columnVal;
                                             }
                                         },

                                         underlyingPrice: {
                                             name: "underlyingPrice",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.undPrice, cellTooltip: true,
                                             displayName: "Underlying Price",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{itm : row.entity.itm, badPosition: row.entity.badPosition}\">{{row.entity.underlyingPrice | strike:row.entity.code.indexOf('XJO') == 0}}</div>"
                                         },
                                         strike: {
                                             name: "strike",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.strike, cellTooltip: true,
                                             displayName: "Strike",
                                             width: "55",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.strike | strike:row.entity.code.indexOf('XJO') == 0}}</div>"
                                         },
                                         expiry: {
                                             name: "expiry",
                                             type: "string", cellTooltip: true,
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.expiry,
                                             displayName: "Expiry",
                                             width: "55",
                                             //grouping: { groupPriority: 1 },
                                             //sort: { priority: 1, direction: 'asc' },
                                             visible: false,
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.expiry | date:'dd MMM yy'}} <span class=\"alt-text\" ng-if=\"row.entity.expiry\">({{row.entity.expiry | daysFromNow}}d)</span></div>",
                                             filterHeaderTemplate: "<div class=\"ui-grid-filter-container\" ng-repeat=\"colFilter in col.filters\"><div class=\"input-group\"><input readonly type=\"text\" class=\"ui-grid-filter-input\" uib-datepicker-popup=\"MMM yy\" datepicker-append-to-body=\"true\" ng-model=\"colFilter.dateTerm\" ng-change=\"grid.appScope.updateFilterTerm(colFilter)\" is-open=\"colFilter.isOpen\" ng-click=\"colFilter.isOpen = true\" show-button-bar=\"false\" ng-init=\"colFilter.mode = 'month'\" datepicker-mode=\"colFilter.mode\" datepicker-options=\"{formatMonth : 'MMM', yearRange : 5, maxMode : 'month', minMode : 'month'}\" /><div class=\"ui-grid-filter-button ng-scope\" ng-click=\"colFilter.term = null;colFilter.dateTerm = null\" ng-if=\"!colFilter.disableCancelFilterButton\"><i class=\"ui-grid-icon-cancel\" ng-show=\"colFilter.term !== undefined && colFilter.term != null\">&nbsp;</i></div></div></div>",
                                             filterable: true,
                                             filters: [{
                                                 flags: {
                                                     date: true
                                                 },
                                                 condition: uiGridConstants.filter.STARTS_WITH
                                             }]
                                         },
                                         type: {
                                             name: "typeFilter",
                                             type: "string", cellTooltip: true,
                                             filter: {
                                                 condition: uiGridConstants.filter.CONTAINS
                                             },
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.type,
                                             displayName: "Type",
                                             width: "60",
                                             visible: false,
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\"></div><div ng-if=\"!row.groupHeader\" class=\"ui-grid-cell-contents\"><span style=\"width:3ch; display: inline-block\">{{row.entity.type | type}}</span><span ng-if=\"row.entity.type == 'PUT' || row.entity.type == 'CALL'\">&nbsp;&ndash;&nbsp;{{row.entity.style | style}}</span></div>"
                                         },
                                         premiumMargin: {
                                             name: "premiumMargin",
                                             type: "number",
                                             cellTooltip: true,
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.premMargin,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             footerCellFilter: "number:0",
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             displayName: "Premium Margin",
                                             width: "**",
                                             visible: false,
                                             cellFilter: "number:2",
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-if=\"row.entity.newBusiness\" uib-tooltip=\"New Business of {{row.entity.newBusiness.premium | number : 2}}\" ng-class=\"{ short : row.entity.newBusiness.premium < 0, long : row.entity.newBusiness.premium > 0}\">{{row.entity.premiumMargin | number:2}}</span><span ng-if=\"!row.entity.newBusiness\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>"
                                         },
                                         whatIfMarginEffect: {
                                             name: "whatIfMarginEffect",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.marginEffect,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             visible: false,
                                             cellTooltip: true,
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             cellFilter: "number:0",
                                             displayName: "Margin Effect",
                                             width: "**",
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{COL_FIELD CUSTOM_FILTERS}}</div>",
                                             footerCellTemplate: "<div class=\"ui-grid-cell-contents\">{{aggregationType}}</div>"
                                         },
                                         whatIfNetEffect: {
                                             name: "whatIfEffect",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.scanEffect, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Net Effect",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.whatIfEffect | number:0}}</div>"
                                         },
                                         scanRisk: {
                                             name: "scanRisk",
                                             type: "number",
                                             cellTooltip: true,
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.scanRisk,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             cellFilter: "number:0",
                                             footerCellFilter: "number:0",
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             displayName: "Scan Risk",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
                                         },

                                         additionalMargin: {
                                             name: "additionalMargin",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.addMargin,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             visible: false, cellTooltip: true,
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             displayName: "Additional Margin",
                                             width: "**",
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.additionalMargin | number:2}}</div>",
                                         },
                                         vol: {
                                             name: "vol",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.vol, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Volatility",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.vol | percentage:2}}</div>"
                                         },
                                         cvf: {
                                             name: "cvf",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.CVF, cellTooltip: true,
                                             enableFiltering: false,
                                             displayName: "CVF",
                                             width: "44",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber"
                                         },
                                         intrinsicValue: {
                                             name: "intrinsicValue",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             cellTooltip: true,
                                             enableFiltering: false,
                                             displayName: "Intrinsic Value",
                                             width: "44",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.intrinsicValue | number:2}}</div>"
                                         },
                                         delta: {
                                             name: "delta",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.delta, cellTooltip: true,
                                             enableFiltering: false,
                                             displayName: "Delta",
                                             width: "55",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.delta | number:4}}</div>"
                                         },
                                         gamma: {
                                             name: "gamma",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.gamma, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Gamma",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.gamma < 0}\">{{row.entity.gamma | number:4}}</div>"
                                         },
                                         vega: {
                                             name: "vega",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.vega, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Vega",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.vega < 0}\">{{row.entity.vega | number:4}}</div>"
                                         },
                                         //theta: {
                                         //    name: 'theta',
                                         //    type: 'number',
                                         //    headerCellTemplate: 'tf/uiGridHeaderCell',
                                         //    term: terms.theta, cellTooltip: true,
                                         //    filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                         //    displayName: 'Theta',
                                         //    width: '**',
                                         //    visible : false,
                                         //    headerCellClass: 'gridNumber',
                                         //    cellClass: 'gridNumber',
                                         //    cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{sell : row.entity.theta < 0}">{{row.entity.theta | number:4}}</div>'
                                         //},
                                         netTheta: {
                                             name: "netTheta",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.netTheta,
                                             cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Net Theta",
                                             width: "**",
                                             visible: false,
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             cellFilter: "number:4",
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.netTheta < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
                                         },
                                         rho: {
                                             name: "rho",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.rho, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Rho",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.rho < 0}\">{{row.entity.rho | number:4}}</div>"
                                         },
                                         netDelta: {
                                             name: "netDelta",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.netDelta,
                                             cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Net Delta",
                                             width: "**",
                                             visible: false,
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             cellFilter: "number:0",
                                             footerCellFilter: "number:0",
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.netDelta < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</div>"
                                         },
                                         dollarDelta: {
                                             name: "dollarDelta",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.dollarDelta, cellTooltip: true,
                                             filter: {condition: uiGridConstants.filter.GREATER_THAN},
                                             displayName: "Dollar Delta",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{sell : row.entity.dollarDelta < 0}\">{{row.entity.dollarDelta | number:0}}</div>"
                                         },
                                         openPrice: {
                                             name: "openPrice",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.openPrice,
                                             enableFiltering: false,
                                             displayName: "Open", cellTooltip: true,
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.openPrice | number:4}}</div>"
                                         },
                                         theoPrice: {
                                             name: "theoPrice",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.theoPrice, cellTooltip: true,
                                             enableFiltering: false,
                                             displayName: "Theo",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.theoPrice | number:3}}</div>"
                                         },
                                         unrealPnL: {
                                             name: "unrealPnL",
                                             type: "number",
                                             cellTooltip: true,
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.pnl,
                                             enableFiltering: false,
                                             displayName: "P&L",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             cellFilter: "ledger:0",
                                             footerCellFilter: "ledger:0",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : row.entity.unrealPnL < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>"
                                         },
                                         todayPnL: {
                                             name: "todayPnL",
                                             type: "number",
                                             headerCellTemplate: "tf/uiGridHeaderCell",
                                             term: terms.todaypnl,
                                             cellTooltip: true,
                                             enableFiltering: false,
                                             displayName: "Today P&L",
                                             width: "**",
                                             visible: false,
                                             headerCellClass: "gridNumber",
                                             cellClass: "gridNumber",
                                             aggregationType: uiGridConstants.aggregationTypes.sum,
                                             aggregationHideLabel: true,
                                             treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                                             customTreeAggregationFinalizerFn: function (aggregation) {
                                                 aggregation.rendered = aggregation.value;
                                             },
                                             cellFilter: "ledger:0",
                                             footerCellFilter: "ledger:0",
                                             cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : row.entity.todayPnL < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>"
                                         }

                                     };

                                     columns.ordered = [
                                         columns.close,
                                         columns.quantity,
                                         columns.code,
                                         columns.security,
                                         columns.securityDescription,
                                         columns.underlyingPrice,
                                         columns.strike,
                                         columns.expiry,
                                         columns.type,
                                         columns.premiumMargin,
                                         columns.whatIfMarginEffect,
                                         columns.whatIfNetEffect,
                                         columns.scanRisk,
                                         columns.additionalMargin,
                                         columns.vol,
                                         columns.cvf,
                                         columns.delta,
                                         columns.gamma,
                                         columns.vega,
                                         columns.intrinsicValue,
                                         //columns.theta,
                                         columns.netTheta,
                                         columns.rho,
                                         columns.netDelta,
                                         columns.dollarDelta,
                                         columns.openPrice,
                                         columns.theoPrice,
                                         columns.unrealPnL,
                                         columns.todayPnL
                                     ];

                                     return columns;
                                 }

                                 $scope.resetColumnFilters = function () {
                                     $scope.gridApi.grid.resetColumnSorting();
                                     $scope.gridApi.grid.clearAllFilters();
                                 };

                                 function createMobileDefaultColumns() {
                                     var columns = setupColumns();
                                     columns.close.visible = false;
                                     columns.quantity.visible = true;
                                     columns.code.visible = true;
                                     columns.securityDescription.visible = false;

                                     columns.security.visible = false;
                                     if (userConfig.strategyBasedView) {
                                         columns.security.grouping = {groupPriority: 1};
                                         columns.security.sort = {priority: 1, direction: "asc"};
                                     }

                                     columns.underlyingPrice.visible = false;
                                     columns.strike.visible = true;
                                     columns.expiry.visible = false;
                                     columns.type.visible = false;
                                     columns.premiumMargin.visible = false;
                                     columns.whatIfMarginEffect.visible = false;
                                     columns.whatIfNetEffect.visible = false;
                                     columns.vol.visible = false;
                                     columns.cvf.visible = false;
                                     columns.delta.visible = false;
                                     columns.netDelta.visible = false;
                                     columns.netTheta.visible = false;
                                     columns.openPrice.visible = false;
                                     columns.theoPrice.visible = false;
                                     columns.unrealPnL.visible = false;
                                     columns.todayPnL.visible = true;


                                     return columns.ordered;
                                 }

                                 function createTabletDefaultColumns() {
                                     var columns = setupColumns();

                                     columns.securityDescription.visible = true;

                                     columns.security.visible = false;
                                     if (userConfig.strategyBasedView) {
                                         columns.close.visible = false;
                                         columns.code.visible = false;
                                         columns.quantity.visible = false;
                                         columns.securityDescription.visible = true;
                                         columns.security.grouping = {groupPriority: 1};
                                         columns.security.sort = {priority: 1, direction: "asc"};
                                     } else {
                                         columns.close.visible = true;
                                         columns.code.visible = true;
                                         columns.quantity.visible = true;
                                         columns.securityDescription.visible = false;
                                     }

                                     columns.underlyingPrice.visible = false;
                                     columns.strike.visible = false;
                                     columns.expiry.visible = false;
                                     columns.type.visible = false;
                                     columns.premiumMargin.visible = false;
                                     columns.whatIfMarginEffect.visible = false;
                                     columns.whatIfNetEffect.visible = false;
                                     columns.vol.visible = false;
                                     columns.cvf.visible = false;
                                     columns.delta.visible = false;
                                     columns.netDelta.visible = false;
                                     columns.netTheta.visible = false;
                                     columns.openPrice.visible = true;
                                     columns.theoPrice.visible = true;
                                     columns.unrealPnL.visible = true;
                                     columns.todayPnL.visible = true;


                                     return columns.ordered;
                                 }

                                 function createCondensedDefaultColumns() {
                                     var columns = setupColumns();

                                     columns.close.visible = false;
                                     columns.quantity.visible = false;
                                     columns.code.visible = false;

                                     columns.security.visible = false;
                                     if (userConfig.strategyBasedView) {
                                         columns.securityDescription.visible = true;
                                         columns.security.grouping = {groupPriority: 1};
                                         columns.security.sort = {priority: 1, direction: "asc"};
                                     } else {
                                         columns.securityDescription.visible = false;
                                     }

                                     columns.underlyingPrice.visible = false;
                                     columns.strike.visible = false;
                                     columns.expiry.visible = false;
                                     columns.type.visible = false;
                                     columns.premiumMargin.visible = true;
                                     columns.whatIfMarginEffect.visible = false;
                                     columns.whatIfNetEffect.visible = false;
                                     columns.vol.visible = false;
                                     columns.cvf.visible = false;
                                     columns.delta.visible = false;
                                     columns.netDelta.visible = true;
                                     columns.netTheta.visible = true;
                                     columns.openPrice.visible = true;
                                     columns.theoPrice.visible = true;
                                     columns.unrealPnL.visible = true;
                                     columns.todayPnL.visible = true;

                                     return columns.ordered;
                                 }

                                 function createDesktopDefaultColumns() {
                                     var columns = setupColumns();
                                     if (userConfig.strategyBasedView) {
                                         columns.close.visible = false;
                                         columns.quantity.visible = false;
                                         columns.code.visible = false;
                                         columns.securityDescription.visible = true;

                                         columns.security.visible = false;
                                         columns.security.grouping = {groupPriority: 1};
                                         columns.security.sort = {priority: 1, direction: "asc"};

                                         columns.underlyingPrice.visible = true;
                                         columns.strike.visible = false;
                                         columns.expiry.visible = false;
                                         columns.type.visible = false;
                                         columns.premiumMargin.visible = true;
                                         columns.whatIfMarginEffect.visible = false;
                                         columns.whatIfNetEffect.visible = true;
                                         columns.vol.visible = false;
                                         columns.cvf.visible = false;
                                         columns.delta.visible = false;
                                         columns.netDelta.visible = true;
                                         columns.netTheta.visible = true;
                                         columns.openPrice.visible = true;
                                         columns.theoPrice.visible = true;
                                         columns.unrealPnL.visible = true;
                                         columns.todayPnL.visible = true;
                                     } else {
                                         columns.close.visible = true;
                                         columns.quantity.visible = true;
                                         columns.code.visible = true;
                                         columns.securityDescription.visible = false;
                                         columns.security.visible = false;
                                         columns.underlyingPrice.visible = true;
                                         columns.strike.visible = true;
                                         columns.expiry.visible = true;
                                         columns.type.visible = true;
                                         columns.premiumMargin.visible = true;
                                         columns.whatIfMarginEffect.visible = false;
                                         columns.whatIfNetEffect.visible = false;
                                         columns.vol.visible = true;
                                         columns.cvf.visible = false;
                                         columns.delta.visible = true;
                                         columns.netDelta.visible = true;
                                         columns.openPrice.visible = true;
                                         columns.theoPrice.visible = true;
                                         columns.unrealPnL.visible = true;
                                         columns.todayPnL.visible = true;
                                     }

                                     return columns.ordered;
                                 }

                                 function createDefaultColumns() {
                                     if (screenSize.is("xs")) {
                                         return createMobileDefaultColumns();
                                     }
                                     if (screenSize.is("sm")) {
                                         return createTabletDefaultColumns();
                                     }
                                     if (screenSize.is("md")) {
                                         return createCondensedDefaultColumns();
                                     }
                                     return createDesktopDefaultColumns();
                                 }


                                 $scope.selectedSecurity = null;
                                 $scope.isSecuritySelected = function (treeNode) {
                                     return treeNode.children.map(function (n) {
                                         return n.row.entity.security;
                                     }).some(function (s) {
                                         return s === $scope.selectedSecurity;
                                     });
                                 };

                                 $scope.gridOptions = {
                                     tableName: "Open Positions",
                                     multiSelect: true,
                                     enableRowSelection: true,
                                     enableFullRowSelection: true,
                                     enableRowHeaderSelection: false,
                                     enableSelectAll: false,
                                     treeRowHeaderAlwaysVisible: false,
                                     flatEntityAccess: true,
                                     enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
                                     enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                                     enablePaging: false,
                                     exporterMenuCsv: false,
                                     exporterMenuPdf: false,
                                     exporterSuppressColumns: ["close"],
                                     exporterCsvFilename: "portfolio.csv",
                                     enableFiltering: true,
                                     enableGridMenu: false,
                                     showGroupPanel: false,
                                     enableColumnResizing: true,
                                     saveFilter: false,
                                     saveScroll: false,
                                     saveFocus: false,

                                     onRegisterApi: function (gridApi) {
                                         $scope.gridApi = gridApi;
                                         gridUtil.disableAnimations(gridApi.grid.element);
                                         gridApi.colMovable.on.columnPositionChanged($scope, saveTablePreferences);
                                         gridApi.core.on.sortChanged($scope, saveTablePreferences);
                                         gridApi.core.on.columnVisibilityChanged($scope, saveTablePreferences);


                                         function rowSelectionChanged(row) {
                                             var selectedRows = $scope.gridApi.selection.getSelectedRows();
                                             if (row.isSelected === false) {
                                                 if (selectedRows.length < 1) {
                                                     $scope.selectedSecurity = null;
                                                 }
                                             } else {
                                                 var security = row.entity.security;
                                                 if ($scope.selectedSecurity !== security) {
                                                     $scope.selectedSecurity = security;
                                                     selectedRows.filter(function (selectedRow) {
                                                         return selectedRow.security !== security;
                                                     }).forEach(function (selectedRow) {
                                                         $scope.gridApi.selection.unSelectRow(selectedRow)
                                                     });
                                                 }
                                             }
                                         }

                                         gridApi.selection.on.rowSelectionChanged($scope, rowSelectionChanged);

                                         gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
                                             rows.forEach(rowSelectionChanged)
                                         });

                                         $timeout(function () {
                                             var settings = $scope.$storage[tableConfigKey];

                                             if (settings != null) {

                                                 if ($scope.gridApi == null) {
                                                     return;
                                                 }

                                                 // Reset if the data isn't versioned
                                                 if (settings.version === undefined) {
                                                     settings.version = 1;
                                                     return;
                                                 }

                                                 if (settings.data) {
                                                     delete settings.data.grouping;
                                                     $scope.gridApi.saveState.restore($scope, settings.data);
                                                 }
                                             }
                                         }, 0);

                                     },
                                     excessRows: 20,
                                     minRowsToShow: 3,

                                     savePreferencesFn: saveTablePreferences,
                                     columnPresets: [
                                         {
                                             name: "Mobile",
                                             icon: "icon-phone2",
                                             minWidth: 400,
                                             resetFn: createMobileDefaultColumns
                                         },
                                         {
                                             name: "Tablet",
                                             icon: "icon-tablet",
                                             minWidth: 700,
                                             resetFn: createTabletDefaultColumns
                                         },
                                         {
                                             name: "Condensed",
                                             icon: "icon-tablet fa-rotate-90",
                                             minWidth: 700,
                                             resetFn: createCondensedDefaultColumns
                                         },
                                         {
                                             name: "Desktop",
                                             icon: "icon-desktop",
                                             minWidth: 1200,
                                             resetFn: createDesktopDefaultColumns
                                         }
                                     ],
                                     columnDefs: createDefaultColumns(),
                                     rowTemplate: "tf-ui-grid/ui-grid-row",
                                     data: $scope.gridData
                                 };

                                 $scope.refresh = function () {
                                     reloadMarginsNow();
                                 };

                                 $scope.updateGrid = function () {
                                     $scope.gridOptions.data = $scope.gridData.filter(function (p) {
                                         return p.quantity !== 0 || $localStorage.showClosedPositions;
                                     });

                                     $scope.gridOptions.data = $scope.gridOptions.data.filter(function (p) {
                                         if (!$scope.includeEquities && p.type === "STOCK") {
                                             return false;
                                         }

                                         return true;
                                     });

                                     $scope.gridOptions.data = $scope.gridOptions.data.filter(function (p) {
                                         if (!$scope.includeOptions && p.type !== "STOCK") {
                                             return false;
                                         }

                                         return true;
                                     });

                                     if ($scope.gridApi) {
                                         $scope.gridApi.treeBase.expandAllRows();
                                     }
                                 };

                                 $scope.updateTableHeight = function () {
                                     // Position grid may be disabled
                                     if (!$scope.gridApi) {
                                         return;
                                     }

                                     var oldRowCount = $scope.gridOptions.minRowsToShow;


                                     if ($scope.fullScreenOpenPos) {
                                         $scope.gridOptions.minRowsToShow = Math.max($scope.gridOptions.data.length, 4);
                                     } else {
                                         $scope.gridOptions.minRowsToShow = 10;
                                     }


                                     if (oldRowCount != $scope.gridOptions.minRowsToShow) {
                                         var newHeight = ($scope.gridOptions.minRowsToShow * $scope.gridOptions.rowHeight) + 60;
                                         $scope.gridApi.grid.gridHeight = newHeight;
                                         // TODO this shouldn't be required as the grid should adjust its render container based on the rows to show or height
                                         angular.element(document.getElementById("open-positions")).css("height", newHeight + "px");
                                         $scope.gridApi.grid.refresh();
                                     }
                                 };

                                 $scope.toggleFullScreenOpenPos = function () {
                                     $scope.fullScreenOpenPos = !$scope.fullScreenOpenPos;

                                     $localStorage["portfolioPrefs_" + $stateParams.portfolioId].fullScreenOpenPos = $scope.fullScreenOpenPos;

                                     $scope.updateTableHeight();
                                 };

                                 $scope.openTablePrefs = function () {
                                     var position = "right";
                                     var backdrop = true;

                                     $scope.asideState = {
                                         open: true,
                                         position: position
                                     };

                                     $aside.open({
                                         templateUrl: "/tradefloor/app/layout/tablePrefs/openPosPref.html",
                                         placement: position,
                                         size: "sm",
                                         backdrop: backdrop,
                                         controller: "TablePrefCtrl",
                                         resolve: {
                                             gridApi: function () {
                                                 return $scope.gridApi;
                                             }
                                         }

                                     });
                                 };

                                 const resizeSub = systemEventService.filter(evt => evt === SystemEvent.VIEW_RESIZE)
                                                                     .filter(() => $scope.gridApi != null)
                                                                     .subscribe(() => $scope.gridApi.grid.handleWindowResize());
                                 $scope.$on("$destroy", () => resizeSub.unsubscribe());

                                 $scope.showScenarios = function () {
                                     $scope.isshowScenarios = !$scope.isshowScenarios;
                                 };

                                 $scope.timeDecayDatePickerDayDisabled = function (d, mode) {
                                     var day = d.getDay();
                                     if (day == 0 || day == 6) {
                                         return true;
                                     }
                                     return false;
                                 };

                                 $scope.timeDecayDatePickerDayClass = function (d, mode) {
                                     var d1 = new Date(d.getTime());

                                     d1.setHours(0);
                                     d1.setMinutes(0);
                                     d1.setSeconds(0);
                                     d1.setMilliseconds(0);

                                     if ($scope.indexExpiry) {
                                         if (d1.getTime() == $scope.indexExpiry.getTime()) {
                                             return "expiry-index";
                                         }
                                     }

                                     if ($scope.etoExpiry) {
                                         if (d1.getTime() == $scope.etoExpiry.getTime()) {
                                             return "expiry-eto";
                                         }
                                     }

                                     return "";
                                 };

                                 $scope.openTimeDecayPicker = function ($event) {
                                     $scope.timeDecayScenario.isOpen = !$scope.timeDecayScenario.isOpen;
                                 };

                                 $scope.changeTimeDecayDate = function () {
                                     if (!$scope.timeDecayScenario.selectedDate || $scope.timeDecayScenario.selectedDate.getTime() == new Date($scope.today).getTime()) {
                                         $scope.timeDecayScenario.asAt = undefined;
                                         $scope.timeDecayScenario.name = "As At EOD";
                                         $scope.selectTimeScenario(null);
                                     } else {
                                         $scope.timeDecayScenario.asAt = $scope.dateFilter($scope.timeDecayScenario.selectedDate, "yyyy-MM-dd");
                                         $scope.timeDecayScenario.name = "As At EOD " + $scope.dateFilter($scope.timeDecayScenario.selectedDate, "MMM dd");

                                         if ($scope.timeParams.activeScenario !== $scope.timeDecayScenario) {
                                             $scope.timeParams.activeScenario = $scope.timeDecayScenario;
                                         }
                                         $scope.timeParams.enabled = true;
                                         $scope.runScenario();
                                     }
                                 };

                                 $scope.timeDecayDatePickerOptions = {
                                     formatYear: "yy",
                                     startingDay: 1,
                                     closeOnDateSelection: true,
                                     showWeeks: false,
                                     appendToBody: true,
                                     maxMode: "month"
                                 };

                                 $scope.viewStrategy = function (whatif) {
                                     $state.go("strategy", {activeStrategy: whatif.linkedStrategyId});
                                 };

                                 $scope.searchTmc = async function() {
                                     try {
                                         const result = await tmcListDialog.open($scope.portfolio.id);
                                         const trades = result.legs.map((l) => ({code: l.code, quantity: l.ratio * (l.side == 'BUY' ? 1 : -1)}));
                                         const whatIf = await $scope.svcCreateWhatIf(result.code, trades, true);
                                         $timeout(function () {
                                             $scope.$broadcast("whatif.flushed");
                                             $scope.setActiveWhatIf(whatIf);
                                         });
                                     } catch (e) {
                                         // Dialog was dismissed
                                     }
                                 }

                                 $scope.buildTmc = function () {
                                     var isWhatIf = $scope.activeWhatIf != null;
                                     strategyService.makeTmc($scope.activeStrategy || $scope.activeWhatIf, isWhatIf, $scope.portfolio.id)
                                                    .then(loadPortfolioAndWhatIf);
                                 };

                                 $scope.updateStrategyLots = function (whatIf) {
                                     whatIf.lots = Math.round(whatIf.lots);
                                     whatIf.lots = Math.max(whatIf.lots, 1);

                                     $http.post(`/tradefloor/api/portfolio/${$scope.portfolio.id}/whatifs/${whatIf.id}/scale`, whatIf.lots)
                                          .then(function (response) {
                                              var data = response.data;

                                              whatIf.trades = data;
                                              // loadPortfolio(true);
                                              reloadMargins(true);
                                              broadcastWhatIfChange(whatIf);
                                          })
                                 };

                                 $scope.$on("whatif.mobile.close", function updateData(event, positions) {
                                     var whatIfPositions = $scope.activeWhatIf.trades;
                                     if (positions.length > 0) {
                                         positions.forEach(function (p) {
                                             var exists = false;
                                             $scope.activeWhatIf.positions.forEach(function (ap) {
                                                 if (ap.code == p.code) {
                                                     exists = true;
                                                 }
                                             });
                                             if (!exists) {
                                                 whatIfPositions.push(p);
                                             }
                                         });
                                     }
                                     $scope.svcUpdateWhatIfTrades($scope.activeWhatIf, whatIfPositions).then(reloadMarginsNow).then(function () {
                                         broadcastWhatIfChange($scope.activeWhatIf);
                                     })
                                 });

                                 $scope.strategyToTrade = null;
                                 $scope.strategyToTradeSummary = null;

                                 const calculateNetDelta = (strategy) => {
                                     const trades = strategy.tradeDetails.concat(strategy.equityTradeDetails);
                                     return trades.map(tr => tr.netDelta).reduce(sum, 0)
                                 };

                                 const calculateStrategySummary = async (strategy) => {
                                     const result = await strategyService.portfolioStrategyResults($scope.portfolio, strategy);
                                     $scope.strategyToTrade = result.strategy;
                                     $scope.strategyToTradeSummary = result.baseStrategy;
                                     $scope.strategyToTradeSummary.netDelta = calculateNetDelta(result.strategy);
                                 };

                                 $scope.convertToTmc = async function (strategy, hideError) {
                                     const tmcStrategy = await strategyService.strategyToTmc(strategy, hideError);
                                     await calculateStrategySummary(tmcStrategy);
                                 };

                                 //    JOYRIDE
                                 $scope.ngJoyridePortConfig = [];

                                 function setupGameJoyride() {
                                     $scope.ngJoyridePortConfig = [];

                                     $scope.ngJoyridePortConfig.push({
                                         type: "title",
                                         heading: "Portfolio Screen",
                                         text: "<span>Welcome to your portfolio dashboard! </span>",
                                         scroll: true

                                     });

                                     $scope.ngJoyridePortConfig.push({
                                         type: "element",
                                         selector: "#openPosContainer",
                                         text: "Your equity and options positions will appear here",
                                         placement: "bottom",
                                         scroll: true,
                                         attachToBody: true

                                     });

                                     $scope.ngJoyridePortConfig.push({
                                         type: "element",
                                         selector: "#widgetContainer",
                                         text: "Here you will find all the tools needed for risk management of your options portfolio.",
                                         placement: "left",
                                         scroll: true,
                                         attachToBody: true

                                     });

                                     $scope.ngJoyridePortConfig.push({
                                         type: "element",
                                         selector: ".strategy-sidebar",
                                         text: "All the strategies you create in the Strategy Builder screen can be viewed here. Clicking on them will turn them blue, which means that the strategy is turned on <strong>as if</strong> you have executed it. <strong>You will need to execute the strategy for it to appear in your current positions.</strong>",
                                         placement: "right",
                                         scroll: true,
                                         attachToBody: true

                                     });

                                     $scope.ngJoyridePortConfig.push({
                                         type: "element",
                                         selector: "#cashView",
                                         text: "In this tab you will find all your cash balances relating to your account. ",
                                         placement: "right",
                                         scroll: true,
                                         attachToBody: true

                                     });
                                 }

                                 if (userConfig.branding == "GAME") {
                                     setupGameJoyride();
                                     $scope.startJoyRide = !$scope.$storage.portfolioTour.complete;
                                     // $scope.startJoyRide = true;
                                 } else {
                                     // setupJoyride();
                                     $scope.startJoyRide = false;
                                 }

                                 $state.current.data.startTour = function () {
                                     $scope.startJoyRide = true;
                                 };

                                 $scope.onFinishTour = function (completed) {
                                     $scope.startJoyRide = false;
                                     $scope.$storage.portfolioTour.complete = true;
                                     $scope.$storage.portfolioTour.skipped = !completed;
                                 };

                             }])
}

// TODO: move it to another file
// TODO: need proper default values.  No reason what is 0 and what is undefined for now.
function makePositionData(overridenValue) {
    overridenValue = overridenValue || {};
    return Object.assign({
        id: null,
        quantity: 0,
        security: undefined,
        code: undefined,
        strike: undefined,
        expiry: undefined,
        type: undefined,
        style: undefined,
        marginEffect: 0,
        delta: 0,
        dollarDelta: 0,
        vega: 0,
        theta: 0,
        rho: 0,
        gamma: 0,
        netDelta: 0,
        netDeltaPercent: 0,
        netVega: 0,
        netTheta: 0,
        netRho: 0,
        netGamma: 0,
        openPrice: 0,
        theoPrice: 0,
        premiumMargin: 0,
        scanRisk: undefined,
        vol: undefined,
        netEffect: 0,
        cvf: 1,
        underlyingPrice: 0,
        unrealPnL: 0,
        todayPnL: 0,
        additionalMargin: 0
    }, overridenValue);
}
